<template>
  <div class="row">
    <div class="modal-backdrop" id="Modal"  v-if="showModalPf">
        <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 580px; width: 750px; " >

          <header class="modal-header">
            <h3>Configure Processing Function</h3>
          </header>
          <section class="modal-body">
          <div class="typepf_reset">
              <div style="margin-left:15px">
                <label>Type Of Function</label>
                <treeselect
                    placeholder="--Choose a Function--"
                    :multiple="false"
                    @select= "filterPf"
                    :options="categories"
                    v-model="currentStoredValue"
                    style="width: 200px" />
              </div>
              <div style="margin-left: 15px">
                <label>Function</label>
                <nv-select @change="getDescription" v-model="functionName" class="form-control" style="width: 415px">
                    <option value="">--Select a Function--</option>
                      <option v-for="(each, index) in selectedCategory" :key="index" :value="each.function_name">
                    {{each.alias}}
                    </option>
                </nv-select>
              </div>
              <div>
              </div>
          </div>
          <div class="row" v-show="stagetype === stageTypes.traditional" style="margin-top:7px;  width:450px; margin-left:15px;">
            <div class="component-style" v-if="functionName">
            <div>
             <a href="#content-pf-description" data-toggle="collapse" class="collapsable-link-panel collapsable-link-panel-child-1" style="color: #fff; font-weight: bold" >Function Description</a>
             </div>
            <div class="panel-body collapse" id="content-pf-description">
            <div style="height: 135px; white-space: break-spaces; overflow-y: auto" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">{{ functionDescription }}</div>
            </div>
            </div>
             <div class="input_age" v-if="functionName === 'navigateToNextStageBasedOnAgeRange'">
              <button  type="button" class="btn btn-primary btn-rounded btn-ageinput" @click="addAgeRange"><i class="fa fa-plus" aria-hidden="true"></i></button> Age Group 
             </div>
             <div v-for="(item, index) in ageList" :key="index" class="age-container">
              <div>
             <input type="text" class="form-control"  v-model="item.ageLowerLimit" placeholder="Age input (From)" style="width: 75%; height: 35px" v-if="functionName === 'navigateToNextStageBasedOnAgeRange'" v-bind:class="{'form-group--error': submitted && functionName === 'navigateToNextStageBasedOnAgeRange' && (!$v.ageList.$each[index].ageLowerLimit.required ||!$v.ageList.$each[index].ageLowerLimit.maxValue || !$v.ageList.$each[index].ageLowerLimit.minValue || !$v.ageList.$each[index].ageLowerLimit.numeric || item.ageLowerLimit === item.ageUpperLimit)}"/>
             <span v-if="submitted && functionName === 'navigateToNextStageBasedOnAgeRange' && (!$v.ageList.$each[index].ageLowerLimit.required || !$v.ageList.$each[index].ageLowerLimit.minValue|| !$v.ageList.$each[index].ageLowerLimit.maxValue || !$v.ageList.$each[index].ageLowerLimit.numeric || item.ageLowerLimit === item.ageUpperLimit)" class="text-red pull-left">Please enter correct age.</span>
             </div>
             <div>
             <input type="text" class="form-control"  v-model="item.ageUpperLimit" placeholder="Age input (To)" style="width: 75%; height: 35px" v-if="functionName === 'navigateToNextStageBasedOnAgeRange'" v-bind:class="{'form-group--error': submitted && functionName === 'navigateToNextStageBasedOnAgeRange' && (!$v.ageList.$each[index].ageUpperLimit.required || !$v.ageList.$each[index].ageUpperLimit.minValue || !$v.ageList.$each[index].ageUpperLimit.maxValue || !$v.ageList.$each[index].ageUpperLimit.numeric || 
             item.ageUpperLimit < item.ageLowerLimit || item.ageLowerLimit === item.ageUpperLimit)}"/>
             <span v-if="submitted && functionName === 'navigateToNextStageBasedOnAgeRange' && (!$v.ageList.$each[index].ageUpperLimit.required || !$v.ageList.$each[index].ageUpperLimit.maxValue || !$v.ageList.$each[index].ageUpperLimit.minValue || !$v.ageList.$each[index].ageUpperLimit.numeric || item.ageUpperLimit < item.ageLowerLimit || item.ageLowerLimit === item.ageUpperLimit)" class="text-red pull-left">Please enter correct age.</span>
             </div>
             <div class="remove-group-btn-container" v-if="functionName === 'navigateToNextStageBasedOnAgeRange'">
                  <button type="button" class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2" style="margin-right: 5px;" @click="removeGroup(index)">
                   <i class="fa fa-minus" aria-hidden="true"></i>
                      </button>
               </div>
             </div>
             <NavigateToNextStageBasedOnKeyword v-if="functionName === 'navigateBasedOnKeyword'"
              :conversationOptions="conversationOptions"
              :allKeywords="allKeywords"
              :keywordMappingList="keywordMappingList"
              @add-keyword-mapping="handleAddKeywordMapping"
              @update-keyword-mapping-list="handleUpdateKeywordConvoMapping"
              ref="keywordMappingValidationComponent"
             />
             <div class="input-conversation">
             <treeselect 
                placeholder="Select conversation"
                v-if="functionName === 'navigateToNextStageFromAnswer'"
                :multiple="false"
                :options="conversationOptions"
                v-model="selectedconversation"
                @input="getStages"
                v-bind:class="{'form-group--error': submitted && functionName === 'navigateToNextStageFromAnswer' && !$v.selectedconversation.required }"
                />
                <span v-if="conversationNotExistError && functionName === 'navigateToNextStageFromAnswer'" class="text-red pull-right"> Please select valid conversation </span>
                <span v-if="submitted && functionName === 'navigateToNextStageFromAnswer' &&!$v.selectedconversation.required" class="text-red pull-right">Please choose conversation.</span>
              </div>
              <div class="input-stage">
             <treeselect 
                placeholder="Select stage"
                v-if="functionName === 'navigateToNextStageFromAnswer'"
                :multiple="false"
                :options="stageOptions"
                @input="getOptions"
                v-model="stageSelected"
                v-bind:class="{'form-group--error': submitted && functionName === 'navigateToNextStageFromAnswer' && !$v.stageSelected.required }"/>
                <span v-if="submitted && functionName === 'navigateToNextStageFromAnswer' && !$v.stageSelected.required" class="text-red pull-right">Please choose stage.</span>
              </div>
              <div>
              <treeselect 
                placeholder="Select Conversation"
                v-if="functionName === 'navigateToNextStageFromScoreRank'"
                :multiple="false"
                :options="scoredResponseConversationOptions"
                @input="getOptionsForScoredResponse"
                v-model="scoredResponseSelected"
                v-bind:class="{'form-group--error': submitted && functionName === 'navigateToNextStageFromScoreRank' && !$v.scoredResponseSelected.required }"
                />
                <span v-if="conversationNotExistError && functionName === 'navigateToNextStageFromScoreRank'" class="text-red pull-right"> Please select valid conversation </span>
                 <span v-if="submitted && functionName === 'navigateToNextStageFromScoreRank' && !$v.scoredResponseSelected.required" class="text-red pull-right">Please choose conversation.</span>
              </div>
            <div class="row" v-if="isInputRequired">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="(functionName === 'navigateToNextStageBasedOnUsersLocation' || functionName === 'navigateToNextStageBasedOnUsersLocationSubstring')" 
               style="display: flex; justify-content: space-between; width: 660px; margin-bottom: 20px; margin-top: -20px;">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" style="padding-left: 0;">
                  <nv-select class="form-control" v-model="locationType" v-bind:class="{'form-group--error': submitted && (functionName === 'navigateToNextStageBasedOnUsersLocation' || functionName === 'navigateToNextStageBasedOnUsersLocationSubstring') && !$v.locationType.required }">
                    <option value="">--Select type of Location--</option>
                    <option v-for="(data, index) in locationOptions" :key="index" :value="data.value">{{data.name}}</option>
                  </nv-select>
                  <span v-if="submitted && (functionName === 'navigateToNextStageBasedOnUsersLocation' || functionName === 'navigateToNextStageBasedOnUsersLocationSubstring') && !$v.locationType.required" class="text-red pull-right">Please choose the type of location.</span>
                </div>
              </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                  <label>Input</label>
                    <textarea v-model="functionInput" type="text" class="form-control" placeholder="Function Input" style="height: 50px"
                     v-bind:class="{'form-group--error': (submitted && !$v.functionInput.required) }"/>
                     <span v-if="submitted && !$v.functionInput.required" class="text-red pull-right">Please enter input.</span>
                   </div>
                </div>
            <div v-if="functionName === 'fetchValueBasedOnSelectedDemographic'">
              <treeselect
                placeholder="--Choose an Option--" 
                :multiple="false"
                :options="demographicOptions"
                v-model="demographicValue"
                @input="updateValue"
                v-bind:class="{'form-group--error': submitted && functionName === 'fetchValueBasedOnSelectedDemographic' && !$v.demographicValue.required }" />
            </div>
             <span v-if="submitted && functionName === 'fetchValueBasedOnSelectedDemographic' && !$v.demographicValue.required" class="text-red pull-right">Please choose an option.</span>             
             <div v-if="functionName === 'setImplicitReferrals'">
              <treeselect
                placeholder="--Choose an Option--" 
                :multiple="true"
                :async="true"
                :defaultOptions="true"
                :load-options="loadOptions"
                :cacheOptions="false"
                v-model="referralValues"
                v-bind:class="{'form-group--error': submitted && !$v.referralValues.required }" />
            </div>
             <span v-if="submitted && !$v.referralValues.required" class="text-red pull-right">Please choose a Referral(s).</span>
             <div v-if="functionName === 'checkUserHaveSpecificReferral'">
              <treeselect
                placeholder="--Choose referral type--"  
                :defaultOptions="true"               
                :options="specificReferralTypes"
                v-model="selectedReferralType"
                v-bind:class="{'form-group--error': submitted && !$v.selectedReferralType.required }" />
            </div>
             <span v-if="submitted && !$v.selectedReferralType.required" class="text-red pull-right">Please choose a referral type.</span>
             <div v-if="functionName === 'checkIfResourceExistNearUserLocation'" style="width: 600px">
              <div style="display: flex; gap: 10px; margin-bottom: 16px">
                <div>
                  <label for="name">Location Type</label>
                  <treeselect
                    placeholder="--Choose location type--"  
                    :defaultOptions="true"               
                    :options="locationTypes"
                    v-model="selectedLocationType"
                    v-bind:class="{'form-group--error': submitted && !$v.selectedLocationType.required }" />
                    <span v-if="submitted && !$v.selectedLocationType.required" class="text-red pull-right">Please choose a location type.</span>
                </div>
                <div>
                  <label for="name">Distance From User</label>
                  <treeselect
                    v-model="selectedKmDistance"
                    :options="kmDistanceOptions"
                    placeholder="Select a number"
                    :clearable="true"
                    :searchable="false" 
                    v-bind:class="{'form-group--error': submitted && !$v.selectedKmDistance.required }" />
                    <span v-if="submitted && !$v.selectedKmDistance.required" class="text-red pull-right">Please choose a distance from user.</span>
                </div>
              </div>
              <div>
                <div class="form-group col-xs-12 col-sm-12 col-md-6">
                  <div class="row">
                  <label for="name" v-bind:class="{'form-group--error': submitted && !$v.selectedKmDistance.required }">Services</label>
                  </div>
                    <span v-if="submitted && !$v.selectedOfferings.required" class="text-red pull-right">Please select the service or product.</span>
                    <label class="checkbox-inline padding-botton-15px"><input type="checkbox" @change="selectAllServices('service')" v-model="allSelectedServices" /> Select All</label>
                      <div v-for="service in servicesList" :key="service.id">
                        <label class="checkbox-inline" style="display: inline-table;">
                            <input  type="checkbox" v-model="selectedOfferings" :value="service.id" @click="selectService('service')"/>{{service.legacy_name}}
                        </label>
                    </div> 
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-md-6">
                  <div class="row">
                  <label for="name" v-bind:class="{'form-group--error': submitted && !$v.selectedKmDistance.required }">Products</label>
                  </div>
                    <span v-if="submitted && !$v.selectedOfferings.required" class="text-red pull-right">Please select the service or product.</span>
                    <label class="checkbox-inline padding-botton-15px"><input type="checkbox" @change="selectAllServices('product')" v-model="allSelectedProducts" /> Select All</label>
                      <div v-for="data in productList" :key="data.id">
                        <label class="checkbox-inline" style="display: inline-table;">
                            <input  type="checkbox" v-model="selectedOfferings" :value="data.id" @click="selectService('product')"/>{{data.legacy_name}}
                        </label>
                    </div> 
                </div>
              </div>
            </div>
          </div>

          <div style="margin-top: 5px; margin-left: 5px">
            <div v-if="optionDisplayArr.length > 0" class="displayOptionsLabel">These options will be configured on the click of "Configure Options & Save" button</div>
            <span class="displayOptions" v-for="(value, index) in optionDisplayArr" :key="index" :value="index">{{value}}</span>
          </div>

          </section>
          <footer class="modal-footer">
            <slot name="footer">
              <div class="footer-buttons">
          <button class="btn btn-primary" v-on:click="closeConfigurePf">
                Close
              </button>
            <input v-if="pfThatRequiresOptionsAutoMagically.includes(functionName)" type="button" class="btn btn-primary" value="Configure Options & Save"  v-on:click="generateOption(functionName)" />
            <input v-else type="button" class="btn btn-primary" value="Save"  v-on:click="configurePfSave()"/>
            </div>
          </slot>
          </footer>
        </div>
    </div>
  <div class="modal-backdrop" id="Modal"  v-if="showModalSemantic">
     <div class="modal-backdrop" id="Modal">
        <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 620px " >

          <header class="modal-header">
              <slot name="header">
                {{captionSemationPopup}}
              </slot>
            </header>
          <section class="modal-body">
            <slot name="body">
              <div v-show="stagetype !== stageTypes.scoreRanking" v-if="isDynamicInputType()" class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="custom-control custom-switch" v-show="semanticObj.option !== 'null_list'">
                <input type="checkbox" v-model="semanticObj.isDynamicOptionsEnable" class="custom-control-input" id="dynamicOptionsCheck" >
                <label class="custom-control-label" for="dynamicOptionsCheck">Dynamic Entity List Options</label>
              </div>
            </div>  
              <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <label for="options">Options</label><span class="text-red">**</span>
              <input type="text" v-model="semanticObj.option" class="form-control" id="option" placeholder="Option"
                :disabled="inputType == 'Boolean'" autocomplete="off"/>
            </div>
            <div class="form-group col-xs-6 col-sm-6 col-md-6">
              <label for="next-stages">Next Stage</label><span class="text-red">**</span>
              <input type="text" v-model="semanticObj.next"  autocomplete="off"
              v-on:keyup="toLowerCaseFuncSematicNext" v-on:blur="toLowerCaseFuncSematicNext" class="form-control" id="next" placeholder="Next stage"  />              <!-- v-bind:class="{'form-group--error': (!semanticObj.next.required)}" -->
            </div>
            </div>
            <div v-show="stagetype === stageTypes.scoredResponse" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <label for="options" class="required">Option Score</label>
              <input type="text"  :class="{'form-group--error': ((!$v.semanticObj.optionScore.required || !$v.semanticObj.optionScore.numberVal) && submittedSemantic)}" v-model="semanticObj.optionScore" class="form-control" id="Option Score" placeholder="Option Score" autocomplete="off"/>
              <span v-if="submittedSemantic && !$v.semanticObj.optionScore.required" class="text-red pull-left">Please enter option score.</span>
              <span v-if="submittedSemantic && !$v.semanticObj.optionScore.numberVal" class="text-red pull-left">Please enter decimal or integer value.</span>
            </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <hr/>
            </div>
          </div>
        
          <div v-show="stagetype === stageTypes.scoreRanking" class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <label for="options">Tally Lower Limit</label>
                <input type="number" placeholder="Tally Lower Limit" v-model="semanticObj.tallyLowerLimit" class="form-control" id="lowerlimit" autocomplete="off"/>
                <span v-if="submittedSemantic && !$v.semanticObj.tallyLowerLimit.numeric" class="text-red pull-left">Please enter a whole number.</span>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <label for="options">Tally Upper Limit</label>
                <input type="number" placeholder="Tally Upper Limit" v-model="semanticObj.tallyUpperLimit" class="form-control" id="upperlimit" autocomplete="off"/>
                <span v-if="submittedSemantic && !$v.semanticObj.tallyUpperLimit.numeric" class="text-red pull-left">Please enter a whole number.</span>
              </div>
            </div>
          </div>

          <div v-show="stagetype !== stageTypes.scoreRanking" class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <label for="options">Semantic Message Set</label>
              </div>
            </div>
          </div>

          <div v-show="stagetype !== stageTypes.scoreRanking" class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
               <div class="form-group col-xs-3 col-sm-3 col-md-3">
                  <label for="options">Country</label>
                <nv-select v-model="selectedCountrySemantic" v-on:change="getLanguagesInCountry()" class="form-control">
                  <option value="">Choose Country</option>
                  <option v-for="(value, key) in countryAndLanguages" :key="key" :value="key">{{key}}</option>
                </nv-select>
              </div>
               <div class="form-group col-xs-3 col-sm-3 col-md-3">
                  <label for="options">Language</label>
                <nv-select class="form-control" v-model="messageLanguageSemantic">
                  <option value="">Choose language</option>
                  <option v-for="(value, index) in languages" :key="index" :value="value.alias">{{value.name}}</option>
                </nv-select>
              </div>

               <div class="form-group col-xs-5 col-sm-5 col-md-5">
                  <label for="options">Message</label>
                  <textarea type="text" class="form-control" id="semanticMessage" name="semanticMessage" placeholder="Semantic Message"  v-model="semanticMessage"></textarea>
              </div>
              <div class="form-group col-xs-1 col-sm-1 col-md-1">
                          <i class="fa fa-plus-circle add-property" v-on:click="addSemanticMessage" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <div v-show="stagetype !== stageTypes.scoreRanking" class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <table class="" style="width:100%; margin-bottom: 20px;" v-if="Object.keys(semanticObj.semantic).length">
              <tr v-bind:key="country" v-for="(countryRow, country) in semanticObj.semantic">
                 <td style="width:15%; background-color: #e8e8e8; border-bottom: 1px solid lightgray;"><strong>{{country}}</strong></td>
                 <td> 
                    <table class="" style="width:100%" v-if="Object.keys(countryRow).length">
                      <thead>
                        <th>Language</th>
                        <th>Text</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </thead>
                      <tr v-bind:key="language" v-for="(languageRow, language) in countryRow">
                        <td style="width:15%; background-color: #f3f2f2;"><strong>{{language}}</strong></td>
                        <td style="width:70%;">{{languageRow}}</td>
                        <td style="width:10%"><i class="fa fa fa-pencil" v-on:click="editSemanticMessage(country, language, languageRow)" aria-hidden="true"></i></td>
                        <td style="width:10%"><i class="fa fa-times-circle" v-on:click="deleteSemanticMessage(country,language)" aria-hidden="true"></i></td>
                      </tr> 
                    </table>
                 </td>  
              </tr>
            </table>
            </div>
          </div>    


          <div v-show="stagetype !== stageTypes.scoreRanking" class="row" v-if="semanticObj.isDynamicOptionsEnable">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group col-xs-6 col-sm-6 col-md-6">
                <label>Option List Source</label>
                <nv-select v-model="semanticObj.optionListSource" class="form-control" id="option" v-on:change="handleOptionListSourceChange()">
                  <option value="">Choose Source</option>
                  <option value="unifiedReferrals">Unified Referrals</option>
                  <option value="offerings">Offerings</option>
                  <option value="drillDownReferrals">Drill Down Referrals</option>
                  <option value="appointmentDates">Appointment Dates</option>
                </nv-select>
              </div>
              <div class="form-group col-xs-6 col-sm-6 col-md-6">
                <label>Data Destination</label>
                <nv-select v-model="semanticObj.dataDestination" class="form-control" id="option">
                  <option value="">Choose Data Destination</option>
                  <option v-for="(value, index) in availableDataDestination" :key="index" :value="value.value">{{value.label}}</option>
                </nv-select>
              </div>
            </div>
          </div>

          <div v-show="stagetype !== stageTypes.scoreRanking" v-if="isDynamicInputType() && !semanticObj.isDynamicOptionsEnable">
            <div class="row" v-show="semanticObj.option !== 'null_list'">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <label for="options">Static Option Display Text</label>
                  </div>
                </div>
              </div>
            <div class="row" v-show="semanticObj.option !== 'null_list'" >
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group col-xs-3 col-sm-3 col-md-3">
                  <label for="options">Country</label>
                  <nv-select v-model="selectedCountryStaticOption" v-on:change="getLanguagesForStaticOption()" class="form-control">
                    <option value="">Choose Country</option>
                    <option v-for="(value, key) in countryAndLanguages" :key="key" :value="key">{{key}}</option>
                  </nv-select>
                </div>
                <div class="form-group col-xs-3 col-sm-3 col-md-3">
                  <label for="options">Language</label>
                  <nv-select class="form-control" v-model="textLanguageStaticOption">
                    <option value="">Choose language</option>
                    <option v-for="(value, index) in languagesForStaticOption" :key="index" :value="value.alias">{{value.name}}</option>
                  </nv-select>
                </div>
                <div class="form-group col-xs-5 col-sm-5 col-md-5">
                  <label for="options">Option Display Text</label>
                  <textarea type="text" class="form-control" id="staticOptionDisplayText" name="staticOptionDisplayText" placeholder="Display Option text"  v-model="staticOptionDisplayText"></textarea>
                </div>
                <div class="form-group col-xs-1 col-sm-1 col-md-1">
                  <i class="fa fa-plus-circle add-property" v-on:click="addStaticOptionDisplayText" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <div v-show="stagetype !== stageTypes.scoreRanking" class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show="semanticObj.option !== 'null_list'">
              <table class="" style="width:100%" v-if="Object.keys(semanticObj.staticOptionTextConfig).length">
                <tr v-bind:key="country" v-for="(countryRow, country) in semanticObj.staticOptionTextConfig">
                  <td style="width:15%; background-color: #e8e8e8; border-bottom: 1px solid lightgray;"><strong>{{country}}</strong></td>
                  <td> 
                      <table class="" style="width:100%" v-if="Object.keys(countryRow).length">
                        <thead>
                          <th>Language</th>
                          <th>Text</th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </thead>
                        <tr v-bind:key="language" v-for="(languageRow, language) in countryRow">
                          <td style="width:15%; background-color: #f3f2f2;"><strong>{{language}}</strong></td>
                          <td style="width:70%;">{{languageRow}}</td>
                          <td style="width:10%"><i class="fa fa fa-pencil" v-on:click="editStaticOptionDisplayText(country, language, languageRow)" aria-hidden="true"></i></td>
                          <td style="width:10%"><i class="fa fa-times-circle" v-on:click="deleteStaticOptionDisplayText(country,language)" aria-hidden="true"></i></td>
                        </tr>  
                      </table>
                  </td>  
                </tr>
              </table>
              </div>
          </div>
          </div>
            </slot>
          </section>
          <div  class="text-red">**Either next stage or Next app is mandatory.</div>
          <div  class="text-red" v-show="stagetype === stageTypes.scoreRanking">*Lowest rank score lower boundary should always be blank</div>
          <div  class="text-red" v-show="stagetype === stageTypes.scoreRanking">*Highest rank score upper boundary should always be blank</div>
            <footer class="modal-footer">
            <slot name="footer">
            <span v-if="!semanticObj.next && !semanticObj.option" class="text-red pull-left" style="font-size:initial; margin: 10px 30px;">Please enter options or next stage</span>
              <span v-show="semanticObj.option !== 'null_list'" v-if="(semanticObj.next || semanticObj.option) && inputType === 'DynamicNumber' && !semanticObj.isDynamicOptionsEnable && _.isEmpty(semanticObj.staticOptionTextConfig)" class="text-red pull-left" style="font-size:initial; margin: 10px 30px;">Please enter Static Option Display Text for given option</span>
              <span v-show="semanticObj.option !== 'null_list'" v-if="(semanticObj.next || semanticObj.option) && semanticObj.isDynamicOptionsEnable && !semanticObj.optionListSource" class="text-red pull-left" style="font-size:initial; margin: 10px 30px;">Please select Option List Source for dynamic options</span>
              <button class="btn btn-primary" v-on:click="closeSemantic()">
                Close
              </button>
              <input type="button" class="btn btn-primary" value="Save"  v-on:click="semanticSave()" />
            </slot>
         </footer>
        </div>
      </div>
    </div>  
    <div class="modal-backdrop" v-if="showModalNullListInfo">
      <div class="modal new-feature" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 200px; width: 518px;">
        <header class="modal-header">
          <div class="header-style">
            <h3>Information</h3>
            <i v-on:click="closeNullListInfoPopUp" class="fa fa-close" style="font-size:22px;color:red" title="Close"></i>
          </div>
        </header>
        <section class="modal-body" style="margin-top: 0px">
          <div class="style-section">
            <div>Whenever we are selecting the input type as Dynamic, a null_list option will be automatically generated.</div>
            <div>The end user would be redirected to the null_list configured stage in case the user does not have any referrals displayed to them.</div>
          </div>
        </section>
      </div>
    </div>
    <div class="modal-backdrop" v-if="showRedemptionStageInfo">
      <div class="modal new-feature" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 200px; width: 518px;">
        <header class="modal-header">
          <div class="header-style">
            <h3>Information</h3>
            <i v-on:click="closeRedemptionStageInfoPopUp" class="fa fa-close" style="font-size:22px;color:red" title="Close"></i>
          </div>
        </header>
        <section class="modal-body" style="margin-top: 0px">
          <div class="style-section">
            <div>After checking this box, the user details will be stored in the provider_visits table when the user answers this question</div>
          </div>
        </section>
      </div>
    </div>
    <form name="frmAddStage" id="frmAddStage" @submit.prevent="addOrUpdateStage" action="#"  method="post">
      <div class="panel panel-primary">
        <div class="panel-heading padding-0">
          <h3 class="text-center panel-title">
            <a href="#content-stage-settings" data-toggle="collapse" class="collapsable-link-panel">
              Stage Settings
            </a>
          </h3>
        </div>
        <div id="content-stage-settings" class="panel-body collapse in">
          <div v-if="disableStageName" class="message-timing">
            <h4 class="message-timing-title">Message timing</h4>
            <p class="message-timing-hint">Applies to every stage in this conversation that sends more than one message(Not on embedded apps, you will have to set delay there separately).</p>
            <div class="form-inline form-group">
              <label class="switch">
                <input type="checkbox" v-model="waitBetweenMessages" @change="handleWaitBetweenMessagesToggle">
                <span class="slider round"></span>
              </label>
              <label class="message-timing-toggle-label">Wait between messages</label>
            </div>
            <div v-if="waitBetweenMessages" class="form-group">
              <label for="messageDelayMs">Delay between messages</label>
              <div class="form-inline">
                <input type="number" id="messageDelayMs" class="form-control" style="width:120px; text-align: right;"
                  v-model.number="messageDelayMs" @input="handleMessageDelayChange"
                  :min="messageDelayLimits.min" :max="messageDelayLimits.max" step="100" />
                &nbsp;milliseconds
              </div>
              <small class="message-timing-hint">Between {{messageDelayLimits.min}} and {{messageDelayLimits.max}} ms.</small>
              <span v-if="!isMessageDelayValid" class="text-red pull-right">Delay must be between {{messageDelayLimits.min}} and {{messageDelayLimits.max}} ms.</span>
            </div>
          </div>
          <div class="row">
            <div class="flex-container">
                <div class="form-group flex-item">
                  <label for="stagename" class="required">Stage Type</label>
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.stagetype.required }" id="stagetype" v-model="stagetype">
                      <option value="">--Select stage type--</option>
                      <option :value="stageTypes.traditional">Traditional</option>
                      <option v-if="conversationType === 'scoredresponse'" :value="stageTypes.scoredResponse">Scored Response</option>
                      <option v-if="conversationType === 'scoredresponse'" :value="stageTypes.scoreRanking">Score Ranking</option>
                      <option :value="stageTypes.embeddedConversation">Embedded Apps</option>
                      <option :value="stageTypes.fbOptIn">Facebook Opt In</option>
                      <option v-if="conversationType === 'journeyReminder'" :value="stageTypes.journeyReminder">Journey of Reminder</option>
                  </nv-select>
                  <span v-if="submitted && !$v.stagetype.required" class="text-red pull-right">Please enter stage type.</span>
                </div>
                <div v-if="stagetype!==stageTypes.embeddedConversation" class="form-group flex-item">
                  <label for="mediatype">Media Type</label>
                  <nv-select class="form-control" :disabled="stagetype !== stageTypes.traditional" id="mediatype" v-model="mediatype"  v-on:change="handleMediaTypeChange">
                      <option value="text">Text</option>
                      <option value="image">Image</option>
                      <option value="video">Video</option>
                      <option value="uploadedMedia">Uploaded Media</option>
                  </nv-select>
                  <span class="text-red text-bold" v-if="mediatype === 'uploadedMedia'">WARNING: Engineers Only! Kindly seek their assistance for content uploads.</span>
                </div>
                <div v-if="stagetype===stageTypes.embeddedConversation" class="form-group flex-item embedded_conversation_container">
                  <div class="conversation_dropdown_container">
                    <label for="conversation" data-toggle="tooltip" data-html="true" v-bind:title="'Please make sure that selected embedded \napp ends with END_CONVERSATION. \nSome apps like WA MIGRATE, SCOUT, \nANC, PNC cannot be used in journey.'">
                      Conversation <i class="fa fa-question-circle"></i>
                    </label>
                    <button v-if="externalConversationButton" type="button" title='Edit Conversation' @click="editEmbeddedConversation"><i class="fa fa-external-link" aria-hidden="true"></i></button>
                  </div>
                  <treeselect
                    placeholder="--Choose a conversation--" 
                    :multiple="false"
                    :options="embeddedApps"
                    v-model="embeddedApp"
                    @input="setOptions" />
                  <span v-if="conversationNotExistError" class="text-red pull-right"> Please select valid conversation </span>
                  <span v-if="showValidationError && !embeddedApp" class="text-red pull-right">Please select a conversation to embed</span>
                  <div v-if="embeddedApp==='APP_UNIFIED_REFERRAL'">
                    <label>Referral Display Option <span :title="'Configure how do we want to show the referral to end user'" style="margin-right: 10px"><i class="fa fa-info-circle margin-10"></i></span></label>
                    <div v-for="option in referralAppOptions" :key="option.value">
                      <label class="radio-inline view-option-radio">
                        <input type="radio" v-model="referralType" :value="option.value"/>{{option.label}}
                      </label>
                    </div>
                     <label class="checkbox-inline public-private-checkbox">
                        <input type="checkbox" v-model="additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection" />Show Physical Resources as per Public/Private Selection
                      </label>
                  </div>
                </div>
            </div>
            <div class="flex-container">
                <div class="form-group flex-item">
                  <label for="stagename" class="required">Stage Name</label>
                  <input type="text" :disabled="disableStageName" v-bind:class="{'form-group--error': submitted && !$v.stagename.required }" v-model="stagename" v-on:keyup="toLowerCaseFunc" v-on:blur="toLowerCaseFunc" class="form-control" id="stagename" placeholder="Name of the stage" />
                  <span v-if="submitted && !$v.stagename.required" class="text-red pull-right">Please enter stage name.</span>
                  <span v-if="submitted && !$v.stagename.stageNameRegex" class="text-red pull-right"> The name can only contain alphanumeric, underscore and hyphen characters.</span>
                </div>
                <div class="form-group flex-item" v-show="stagetype !== stageTypes.scoreRanking && mediatype != 'uploadedMedia'" >
                  <label for="input-type">Input Type</label>
                  <nv-select :disabled="mediatype!=='text'|| [stageTypes.embeddedConversation, stageTypes.fbOptIn, stageTypes.journeyReminder].includes(stagetype)" id="input-type" v-model="inputType" class="form-control" v-on:change="setOptions(true)">
                      <option value="">--No input--</option>
                      <option value="Number">Number</option>
                      <option value="Boolean">Boolean</option>
                      <option value="Text">Text</option>
                      <option value="DynamicNumber">Dynamic</option>
                      <option value="whatsapp_flows">WhatsApp Flows</option>
                      <option v-if="convoCurrent.topic_id" value="nlpDecision">NLP Decision</option>
                  </nv-select>
                </div>
                <div class="form-group flex-item" v-show="mediatype === 'uploadedMedia'">
                  <label for="input-type">Select Media</label>
                  <treeselect
                    placeholder="--Choose a media--" 
                    :multiple="false"
                    :options="mediaList"
                    v-model="uploadedMedia" />
                  <!-- The picked file itself (its first stored copy — a conversation isn't tied
                       to one country), so the right one is chosen. -->
                  <div v-if="selectedMedia" class="stage-media-preview">
                    <media-preview
                      :format="selectedMedia.media_format || selectedMedia.media_type || 'image'"
                      :media-id="selectedMedia.id"
                      :media-name="selectedMedia.media_name"
                      missing-text=": no stored file"
                    />
                  </div>
                </div>
            </div>
            <div class="flex-container" v-show="inputType === 'whatsapp_flows'">
              <div class="form-group flex-item">
                <label for="whatsapp-flow-id">WhatsApp Flow</label>
                <nv-select id="whatsapp-flow-id" v-model="whatsappFlowId" class="form-control">
                  <option value="">--Select a Flow--</option>
                  <option v-for="flow in whatsappFlows" :key="flow.id" :value="flow.id">{{ flow.name }}</option>
                </nv-select>
              </div>
            </div>
            <div class="flex-container">
              <div class="form-group flex-item" v-show="inputType === 'DynamicNumber'">
                  <label class="checkbox-inline referral-check-box" style="font-weight: bold">
                    <input type="checkbox" v-model="isRedemptionStage" @change="changeRedemptionStage" />Is redemption stage
                    <i v-show="inputType === 'DynamicNumber'" class="fa fa-info-circle" v-on:click="showRedemptionStageInfoPopUp" aria-hidden="true" style="margin-left: 5px; font-size: 15px;"></i>
                  </label>
                  
                </div>
            </div>

            <div class="flex-container" v-show="stagetype === stageTypes.fbOptIn">
              <div class="form-group flex-item">
                <label for="stagename" class="required">Topic</label>
                  <treeselect
                    placeholder="--Choose a topic--" 
                    :multiple="false"
                    :options="topicList"
                    v-model="topic" />
                  <span v-if="showValidationError && !topic" class="text-red pull-right">Please select a topic</span>
              </div>
              <div class="form-group flex-item">
                <label for="input-type">Frequency</label>
                <nv-select :disabled="true" id="frequency-type" v-model="frequency" class="form-control" v-on:change="setOptions">
                    <option value="DAILY">Daily</option>
                    <option value="WEEKLY">Weekly</option>
                    <option value="MONTHLY">Monthly</option>
                </nv-select>
              </div>
            </div>
          </div>
          <!-- ADD OPTION AND NEXT STAGE UI -->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group" style="padding:6px 12px">
                  <label for="option_nextstage">Option / Next Stage / Semantic Text </label>
                  <i class="fa fa-plus-circle add-property" v-on:click="openSemantic()" aria-hidden="true" style="margin-left: 20px;"></i>
                  <i v-show="inputType === 'DynamicNumber'" class="fa fa-info-circle" v-on:click="showNullListInfoPopUp" aria-hidden="true" style="margin-left: 55px; font-size: 22px;"></i>
                  <div  v-if="showValidationError" class="text-red" ref="errorDiv">{{ errorMessage }}</div>
                  <table class="table table-striped">
                      <thead class="thead-dark">
                        <tr>
                            <th style="width: 100px"></th>
                            <th class="text-center">Option</th>
                            <th class="text-center">Next Stage</th>
                            <th class="text-center" v-if="stagetype === stageTypes.scoredResponse" >Option Score</th>
                            <th class="text-center" v-if="stagetype === stageTypes.scoreRanking">Tally Lower Limit</th>
                            <th class="text-center" v-if="stagetype === stageTypes.scoreRanking">Tally Upper Limit</th>
                        </tr>
                      </thead>
                      <draggable v-model="semanticData" tag="tbody"  v-if="semanticData && Object.keys(semanticData).length"  @end="listMoved" :disabled="!draggable"  >
                        <tr v-for="(item, index) in semanticData" :key="item.option">
                            <td class="edit-delete-btn-container">
                              <i class="fa fa-align-justify handle"></i>
                              <i @click="openSemantic(item, index)" class="fa fa-pencil" aria-hidden="true"></i>
                              <i @click="deleteSemantic(item,index)" class="fa fa-times-circle" aria-hidden="true"></i>
                            </td>
                            <td><span class="text-center wrap-text-block">{{ item.option }}</span></td>
                            <td><span class="text-center wrap-text-block">{{ item.next }}</span></td>
                            <td class="text-center" v-if="stagetype === stageTypes.scoredResponse"> {{ item.optionScore }} </td>
                            <td class="text-center" v-if="stagetype === stageTypes.scoreRanking"> {{ item.tallyLowerLimit }} </td>
                            <td class="text-center" v-if="stagetype === stageTypes.scoreRanking"> {{ item.tallyUpperLimit }} </td>
                        </tr>
                      </draggable>
                  </table>
                  <!-- {{semanticData}} -->
                </div>
            </div>
          </div>
          
          <div v-show="stagetype !== stageTypes.traditional" class="row">
            <div class="form-group flex-container">
              <div class="form-group flex-item col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                <label for="tags">Analysis Tags</label>                  
                <treeselect placeholder="Add Tag" 
                  :multiple="true" 
                  :options="tagTypes" 
                  v-model="tags"
                />  
              </div>
              <div class="flex-item"></div>
            </div>
          </div>
          <div v-show="stagetype === stageTypes.traditional">
            <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 flex-container">
                  <div class="form-group flex-item">
                      <div>
                        <div class="form-inline form-group">
                            <label>Scheduled Conversation (Optional)</label>
                            <label class="switch">
                            <input type="checkbox"  v-model="toggleSwitchDelay" @change="handleDelayToggle">
                            <span class="slider round"></span>
                            </label>
                        </div>
                          <div v-show="showDelayTactics" ref="errorKeywordConversation">

                              <!-- Select First Template section -->
                              <div class="form-inline form-group" style="margin-top:10px">
                                <label>Message Template Name </label>
                                <div style="display: flex">
                                  <nv-select @change="onTemplateChangeCalculateButtonLength()"  id="input-type" v-model="msgTemplateName" style="width: 100%" class="form-control">
                                    <option value="">--Select Template--</option>
                                    <option v-for="(each, key) in nudgesList" :key="key"
                                      :value="each.msg_template_name">{{each.msg_template_name}}</option>
                                  </nv-select>
                                  <div v-if="msgTemplateName" style="width: 100px">
                                    <button type="button" class="btn btn-link" @click="onNudgePreviewClick(msgTemplateName, {dynamic_value_configuration: dynamic_value_configuration, msg_template_name: msgTemplateName})">{{isDynamicTemplate('',msgTemplateName) ? 'Configure' : 'Preview'}}</button><small v-if="turnCountry" class="turn-country-hint">from {{turnCountry}}</small>
                                  </div>
                                </div>
                                <div>
                                    <span v-if="isInvalidMessageTemplate && !msgTemplateName && scheduledAppKeyword !== -1" class="text-red pull-right ">Please select message template</span>
                                    <span v-if="isInvalidMessageTemplate && msgTemplateName && !checkIfNudgeConfigurationValid({dynamic_value_configuration: dynamic_value_configuration, msg_template_name: msgTemplateName})" class="text-red pull-right">Please configure dynamic nudge.</span>
                                </div>
                              </div>

                              <!-- Context selection -->
                              <div class="nudge-container">
                              <div class="form-inline form-group"  style="padding-bottom:10px;">
                                <label>Context </label> &nbsp;
                                <treeselect placeholder="--Select Context--" :multiple="false" :options="contextOptions"
                                    v-model="followupNudges.context" @input="setContextOption" />
                              </div>


                              <!-- Add Multiple nudge section -->
                                <div class="margin-bottom-20" style="font-weight: bold" v-if="followupNudges.context">
                                  <button type="button" class="btn btn-primary btn-rounded btn-nudge" @click="addNudge"><i class="fa fa-plus" aria-hidden="true"></i></button> Add Nudge
                                </div>
                                <div v-for="(nudgeDelay, index) in followupNudges.delays" ref="nudgeDiv" v-bind:key="index">
                                  <div style="display: flex;">
                                    <label>Delay Nudge {{ index + 1 }}:</label>
                                    <button 
                                      type="button" 
                                      class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2 btn-sm"
                                      @click="deleteConversation(index)">
                                      <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                  </div>
                                  <div class="flex-container option-border" style="padding: 0px; margin-bottom: 10px; padding-top: 10px;">
                                    <div class="form-group flex-small-item">
                                      <label for="Conversation">Delay until next nudge</label>
                                      <div style="display: flex">
                                        <input type="text" v-model="nudgeDelay.quantity" class="form-control"
                                          style="width:60px; text-align: right;" placeholder="Delay"/>
                                        <nv-select id="input-type" v-model="nudgeDelay.units" class="form-control" style="margin-left: 10px; width:100%">
                                            <option value="">--Select Unit--</option>
                                            <option value="hrs">hrs</option>
                                            <option value="days">days</option>
                                        </nv-select>                                
                                      </div>
                                      <span v-if="showValidationError && (nudgeDelay.msg_template_name || scheduledAppKeyword === -1) && !(nudgeDelay.quantity && nudgeDelay.units)" class="text-red">Please select delay and Unit.</span>
                                        <span v-if="showValidationError && ((nudgeDelay.units === 'hrs' && nudgeDelay.quantity < 24) || (nudgeDelay.units === 'days' && nudgeDelay.quantity < 1))" class="text-red">Delay should be minimum 24 hours or 1 day.</span>
                                    </div>

                                    <div class="flex-small-item flex-message-template">
                                      <div>
                                        <label style="white-space: pre">Message Template Name : </label>
                                        <nv-select @change="onTemplateChangeCalculateButtonLength(nudgeDelay)" id="input-type" v-model="nudgeDelay.msg_template_name" class="form-control">
                                            <option value="">--Select Template--</option>
                                            <option v-for="(each, key) in nudgesList" :key="key"
                                              :value="each.msg_template_name">{{each.msg_template_name}}</option>
                                        </nv-select>
                                        <div>
                                            <span v-if="showValidationError && (nudgeDelay.quantity || nudgeDelay.units) && !nudgeDelay.msg_template_name && scheduledAppKeyword !== -1 " class="text-red pull-right ">Please select message template</span>
                                            <span v-if="nudgeDelay.msg_template_name && showValidationError && !checkIfNudgeConfigurationValid(nudgeDelay)" class="text-red pull-right">Please configure dynamic nudge.</span>
                                        </div>
                                        <div style="min-height: 15px;">
                                          <div v-if="nudgeDelay.msg_template_name">
                                            <button type="button" class="btn btn-link" @click="onNudgePreviewClick(nudgeDelay.msg_template_name, nudgeDelay, true)">{{isDynamicTemplate('',nudgeDelay.msg_template_name) ? 'Configure' : 'Preview'}}</button><small v-if="turnCountry" class="turn-country-hint">from {{turnCountry}}</small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Delay Time selection -->
                              <div class="form-inline form-group" style="margin-top:20px"
                                >
                                <label>Delay : </label> &nbsp;
                                <input type="text" v-model="delay.quantity" class="form-control"
                                    style="width:60px; text-align: right;" placeholder="Delay"
                                    v-on:keyup="validateDelay($event)"/>
                                &nbsp;
                                <nv-select id="input-type" v-model="delay.units" class="form-control" style="width:90px"
                                    v-on:change="validateDelay()">                                    
                                    <option value="mins">mins</option>
                                    <option value="hrs">hrs</option>
                                    <option value="days">days</option>
                                </nv-select>
                                &nbsp;
                                <i class="fa fa-times-circle fa-lg" v-on:click="resetDelay()" aria-hidden="true"></i>
                                &nbsp; &nbsp;
                                <span v-if="isInvalidDelay" class="text-red">Delay is minimum 60 minutes.</span>
                              </div>
                              <div style="margin-left: 20px">
                                <span
                                    class="badge badge-warning"> ------ Or/And ------ </span>
                              </div>
                              <div class="form-inline form-group" style="margin-top:10px;min-width: 290px;"
                                >
                                <label>Send Time (24-hour) : </label> &nbsp;
                                <input type="text" min="0" max="23" v-model="sendTime.hours" class="form-control"
                                    style="width:50px; text-align: right;" placeholder="HH"
                                    v-on:keyup="validateSendTime($event)" />
                                &nbsp; : &nbsp;
                                <input type="text" min="0" max="59" v-model="sendTime.minutes" class="form-control"
                                    style="width:50px; text-align: right;" placeholder="MM"
                                    v-on:keyup="validateSendTime($event)" />
                                &nbsp;
                                <i class="fa fa-times-circle fa-lg" v-on:click="resetSendTime()" aria-hidden="true"></i>
                                &nbsp; &nbsp;
                                <span v-if="isInvalidSendTime" class="text-red ">Please enter valid time</span>
                              </div>

                              <!-- new kconvo -->
                              <div v-for="(entry, index) in entries" :key="index" >
                                <label>Button Option {{ index + 1 }}:</label>
                                <div class="option-border"> 
                                <div class="form-inline form-group" style="margin-bottom:0px">
                                  <label>Keyword</label> &nbsp;
                                  <treeselect
                                    :disabled="!!entry.scheduledKeywordlessConversation"
                                    placeholder="--Select keyword--"
                                    :multiple="false"
                                    :options="allKeywords"
                                    v-model="entry.scheduledAppKeyword"
                                    @input="validateScheduledAppKeywordNew(index, $event)"
                                  />
                                  <div v-if="entry.isInvalidKeywordConversation">
                                    <span class="text-red">Please select keyword or keywordless conversation</span>
                                  </div>
                                </div>
                                <div class="form-inline form-group" style="margin-top:10px;margin-bottom:10px">
                                  <label>Conversation : </label> &nbsp;
                                  <label v-if="entry.scheduledAppConversation">{{ entry.scheduledAppConversation }}</label>
                                  <label v-if="!entry.scheduledAppConversation || entry.scheduledKeywordlessConversation"> - </label>
                                </div>
                                <div v-bind:class="{'disabledDiv': !entry.scheduledAppKeyword && !entry.scheduledKeywordlessConversation}" style="margin-left: 20px">
                                  <span class="badge badge-warning"> ------ Or ------ </span>
                                </div>
                                <div class="form-inline form-group" style="margin-top:10px; margin-bottom: 0px">
                                  <label>Keywordless Conversation </label> &nbsp;
                                  <treeselect
                                    :disabled="!!entry.scheduledAppKeyword"
                                    placeholder="--Select keywordless conversation--"
                                    :multiple="false"
                                    :options="keywordlessConvoNew"
                                    v-model="entry.scheduledKeywordlessConversation"
                                    @input="validateScheduledKeywordlessConversationNew(index, $event)"
                                  />
                                  <div v-if="entry.isInvalidKeywordConversation">
                                    <span class="text-red">Please select keywordless conversation or keyword</span>
                                  </div>
                                </div>
                                </div>
                              </div>



                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                              <div v-show="!isScreening">
                                  <label>Recommendation</label>
                                  <label class="switch">
                                  <input type="checkbox" v-model="toggleSwitchRecommendation"
                                    @change="handleRecommendationToggle">
                                  <span class="slider round"></span>
                                  </label>
                                  <div v-show="toggleSwitchRecommendation">
                                    <nv-select multiple v-model="recommendation" class="form-control">
                                        <option v-for="(value, key) in allMethods" :key="key" :value="key">{{value.name + '[' + value.altName + ']'}}</option>
                                    </nv-select>
                                  </div>
                              </div>
                            </div>
                        </div>

                        <div class="row">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                            <label for="tags">Analysis Tags</label>                  
                            <treeselect placeholder="Add Tag" 
                              :multiple="true" 
                              :options="tagTypes" 
                              v-model="tags"
                            />  
                          </div>
                        </div>

                      </div>
                  </div>
                  <div class="form-group flex-item">
                      <div class="row">
                        <div class="form-group col-xs-12 col-sm-12 col-lg-12">
                          <div class="reload-conversation">
                            <label>Next App (if any) <span :title="'Subsequent app is available for Unified \nReferral and Location for Referral only'" style="margin-right: 10px"><i class="fa fa-info-circle margin-10"></i></span></label>
                            <div class="refresh-conversation">
                              <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="refreshApps()"></div></a>
                            </div>
                          </div>
                          <treeselect placeholder="--Select App--" :multiple="false" :options="allApps" v-model="nextApp" @input="setOptions" />
                        <div v-if="nextApp==='APP_UNIFIED_REFERRAL'">
                          <label>Referral Display Option <span :title="'Configure how do we want to show the referral to end user'" style="margin-right: 10px"><i class="fa fa-info-circle margin-10"></i></span></label>
                          <div v-for="option in referralAppOptions" :key="option.value">
                            <label class="radio-inline view-option-radio">
                              <input type="radio" v-model="referralType" :value="option.value"/>{{option.label}}
                            </label>
                          </div>
                          <label class="checkbox-inline public-private-checkbox">
                            <input type="checkbox" v-model="additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection" />Show Physical Resources as per Public/Private Selection
                          </label>
                        </div>
                      </div>    
                    </div>
                      <div class="row">
                        <div class="form-group col-xs-12 col-sm-12 col-lg-12">
                            <label>Subsequent App (The App/Conversation that comes after Next App)</label>
                            <treeselect placeholder="--Select Subsequent App--" :multiple="false" :options="filteredApps" v-model="subsequentApp" @input="setOptions" :disabled="isDisabledSubsequentApp" />
                            <div v-if="subsequentApp==='APP_UNIFIED_REFERRAL'">
                              <div v-for="option in referralAppOptions" :key="option.value">
                                <label class="radio-inline view-option-radio">
                                  <input type="radio" v-model="referralType" :value="option.value"/>{{option.label}}
                                </label>
                              </div>
                              <label class="checkbox-inline public-private-checkbox">
                                <input type="checkbox" v-model="additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection" />Show Physical Resources as per Public/Private Selection
                              </label>
                            </div>
                        </div>
                      </div>
                      <div class="row" v-if="false">
                      <!-- Disabled the failed field as per the comment on AS-4871 pdf -->
                        <div class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label data-toggle="tooltip" data-html="true"  title="Use this option to direct the user to a different stage in the event they enter an incorrect input">
                              Failed <i class="fa fa-question-circle"></i>
                            </label>
                            <input type="text" v-model="failed" class="form-control" placeholder="Next stage if there's an input failure" />
                        </div>
                      </div>
                      <div class="row" v-show="stagetype === stageTypes.traditional" style="margin-top:10px">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 alignfd" >
                          <button v-on:click="configurePf" class="btn btn-configurepf"> {{(this.stageDetails && this.stageDetails.processingFunctionConfig && this.stageDetails.processingFunctionConfig.functionName) ? 'Edit PF' : 'Configure PF'}} </button>
                          <button  v-on:click="deletePf" class="btn btn-deletepf" v-if="functionAlias"> Delete PF </button>
                          <div class="displaypf" v-if="functionAlias"><b>{{functionAlias}}</b></div>
                        </div>  
                        
                      </div>
                  </div>
                </div>
            </div>
          </div>

          <div v-show="stagetype === stageTypes.journeyReminder">
            <div class="row">
                <div class="form-group flex-container">
                  <div ref="errorKeywordConversation" class="flex-item">
                      <div class="form-inline form-group">
                        <label>Delay : </label> &nbsp;
                        <input type="text" v-model="delay.quantity" class="form-control"
                            style="width:60px; text-align: right;" placeholder="Delay"
                            v-on:keyup="validateDelay($event)"/>
                        &nbsp;
                        <nv-select id="input-type" v-model="delay.units" class="form-control" style="width:90px"
                            v-on:change="validateDelay()">
                            <option value="hours">hours</option>
                            <option value="days">days</option>
                            <option value="weeks">weeks</option>
                        </nv-select>
                        &nbsp;
                        <i class="fa fa-times-circle fa-lg" v-on:click="resetDelay()" aria-hidden="true"></i>
                        &nbsp; &nbsp;
                        <span v-if="isInvalidDelay" class="text-red">Delay should be minimum 1 hour.</span>
                      </div>
                      <div style="margin-left: 20px">
                        <span
                            class="badge badge-warning"> ------ Or/And ------ </span>
                      </div>
                      <div class="form-inline form-group" style="margin-top:10px">
                        <label>Send Time (24 hours) (Optional)</label> &nbsp;
                        <input type="text" min="0" max="23" v-model="sendTime.hours" class="form-control"
                            style="width:50px; text-align: right;" placeholder="HH"
                            v-on:keyup="validateSendTime($event)" />
                        &nbsp; : &nbsp;
                        <input type="text" min="0" max="59" v-model="sendTime.minutes" class="form-control"
                            style="width:50px; text-align: right;" placeholder="MM"
                            v-on:keyup="validateSendTime($event)" />
                        &nbsp;
                        <i class="fa fa-times-circle fa-lg" v-on:click="resetSendTime()" aria-hidden="true"></i>
                        &nbsp; &nbsp;
                        <span v-if="isInvalidSendTime" class="text-red ">Please enter valid time</span>
                      </div>

                      <div class="form-inline form-group" style="margin-top:10px;">
                        <label>Message Template Name : </label> &nbsp;
                        <div style="display: flex">
                          <nv-select @change="onTemplateChange()" id="input-type" v-model="msgTemplateName" style="width: 100%" class="form-control">
                            <option value="">--Select Template--</option>
                            <option v-for="(each, key) in nudgesList" :key="key"
                              :value="each.msg_template_name">{{each.msg_template_name}}</option>
                          </nv-select>
                          <div v-if="msgTemplateName" style="width: 100px">
                            <button type="button" class="btn btn-link" @click="onNudgePreviewClick(msgTemplateName, {dynamic_value_configuration: dynamic_value_configuration, msg_template_name: msgTemplateName})">{{isDynamicTemplate('',msgTemplateName) ? 'Configure' : 'Preview'}}</button><small v-if="turnCountry" class="turn-country-hint">from {{turnCountry}}</small>
                          </div>
                        </div>
                        <div>
                            <span v-if="isInvalidMessageTemplate && !msgTemplateName" class="text-red pull-right ">Please select message template</span>
                            <span v-if="msgTemplateName && !checkIfNudgeConfigurationValid({dynamic_value_configuration: dynamic_value_configuration, msg_template_name: msgTemplateName})" class="text-red pull-right">Please configure dynamic nudge.</span>
                        </div>

                      </div>
                </div>
                  <div class="flex-item"></div>
                </div>
            </div>
          </div>

        </div>
      </div>
      <div  v-if="showMessageSetValidationError" class="text-red" ref="messageSetTop">{{ messageSetErrorMessage }}</div>
      <message-set v-if="stagetype!==stageTypes.embeddedConversation && stagetype!==stageTypes.journeyReminder"
        v-show="mediatype !== 'uploadedMedia'" 
        :allMessages="allMessages" 
        :stageName="stagename"
        :mediaType="mediatype" 
        :countryAndLanguages="countryAndLanguages"
        ref='messageSet'
      />

      <br clear="all" />
    </form>
    <div v-show="isScreening">
      <h4 class="text-center">Methods Addition/Removal</h4>
      <br clear="all" />
      <form @submit.prevent="addOrRemoveMethod" action="#"  method="post">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
                  <label>Option</label>
                  <nv-select v-model="methodOption" class="form-control">
                    <option value="">--Select Option--</option>
                    <option v-for="(each, index) of allOptions" :key="index">{{each}}</option>
                  </nv-select>
                </div>
                <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6">
                  <label>Action</label>
                  <nv-select v-model="methodTypeModification" class="form-control" v-bind:class="{'form-group--error': frmAddRemoveMethodSubmitted && methodTypeModificationRequired }">
                    <option value="">--Select Action--</option>
                    <option value="add">Add Methods</option>
                    <option value="remove">Remove Methods</option>
                  </nv-select>
                  <span v-if="frmAddRemoveMethodSubmitted && methodTypeModificationRequired" class="text-red pull-right">Please select method action.</span>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="row">
                  <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                    <label>Methods</label>
                    <nv-select multiple v-model="choosenMethods" class="form-control">
                      <option v-for="(value, key) in allRecommendationMethods" :key="key" :value="key">{{value.name + ' [' + value.altName + ']'}}</option>
                    </nv-select>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <label>&nbsp;&nbsp;&nbsp;</label>
                    <i class="fa fa-plus-circle add-property" v-on:click="addOrRemoveMethod" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <br clear="all"/>
      <div class="methods-container" v-show="showMethodsTable">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12">
            <div class="row">
              <div class="col-md-3 col-lg-3 col-sm-3 col-xs-3">
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6"><label>Option</label></div>
                  <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6"><label>Action</label></div>
                </div>
              </div>
              <div class="col-md-9 col-lg-9 col-sm-9 col-xs-9">
                <div class="row">
                  <div class="col-md-11 col-lg-11 col-sm-11 col-xs-11"><label>Methods</label></div>
                  <div class="col-md-1 col-lg-1 col-sm-1 col-xs-1">&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-for="(value, eachOption) in methods" :key="eachOption">
          <div class="col-md-12 col-lg-12 col-sm-12">
            <div class="row">
              <div class="col-md-3 col-lg-3 col-sm-3 col-xs-3">
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">{{eachOption}}</div>
                  <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">{{value.type}}</div>
                </div>
              </div>
              <div class="col-md-9 col-lg-9 col-sm-9 col-xs-9">
                <div class="row">
                  <div class="col-md-11 col-lg-11 col-sm-11 col-xs-11">{{value.methods}}</div>
                  <div class="col-md-1 col-lg-1 col-sm-1 col-xs-1"><i class="fa fa-times-circle add-property" v-on:click="deleteMethodOption(eachOption, methods)" aria-hidden="true"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br clear="all"/>
    </div>


    <div class="modal-backdrop" v-if="showNudgePreview">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
          <div style="margin: 20px; max-height: 400px; overflow-y: auto;">
            <slot name="body">
              <div class="margin-bottom-10px">
                <template v-if="showCountryPicker">
                  <span class="nudge-language">Country :</span>
                  <nv-select class="form-control" style="display:inline-block; min-width:180px; vertical-align:middle" v-model="turnCountry" v-on:change="onTurnCountryChange()">
                    <option value="">-- Select Country --</option>
                    <option v-for="country in turnCountryList" :key="country" :value="country">{{country}}</option>
                  </nv-select>
                  <div style="margin-top:8px">Templates differ per country's Turn namespace. Select a country to load them.</div>
                </template>
                <template v-else>
                  <span>Templates from <b>{{turnCountry}}</b></span>
                  <button v-if="turnCountryList.length > 1" type="button" class="btn btn-link" v-on:click="showCountryPicker = true">Change Country</button>
                </template>
              </div>
              <div v-if="turnCountry">
              <div class="nudge-origin-title">WhatsApp Nudge(s):</div>
              <div class="margin-bottom-10px" v-for="(data, index) in nudgePreviewData" :key="'nudge' + index">
                <span class="nudge-language">{{data.language}} :</span>
                <!-- A media header: the file set on the template (first stored copy). -->
                <div v-if="data.turn_template_data && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(data.turn_template_data.HEADER_FORMAT)" style="max-width: 260px">
                  <media-preview
                    :format="data.turn_template_data.HEADER_FORMAT"
                    :media-id="data.media_id"
                    :media-name="data.media_name || ''"
                    :file-name="data.media_file_name || ''"
                    :language-id="data.language_id"
                  />
                </div>
                <div v-if="data.turn_template_data && data.turn_template_data.HEADER" class="nudge-whatsapp-header">
                  <span v-for="(part, index) in data.headerObj.text" :key="'header' + index">
                    {{ part }}<input v-model="data.headerObj.gaps[index]" placeholder="Enter text for header" v-on:keyup="trimMoreThan4Spaces" v-on:blur="trimMoreThan4Spaces" style="width: 500px;">
                  </span>
                  <span>{{ data.headerObj.last }}</span>
                </div>
                <div v-if="data.turn_template_data && data.turn_template_data.BODY" class="nudge-whatsapp-body">
                  <span v-for="(part, index) in data.bodyObj.text" :key="'body' + index" style="white-space: pre-wrap ">{{ part }}<input v-model="data.bodyObj.gaps[index]" v-on:keyup="trimMoreThan4Spaces" v-on:blur="trimMoreThan4Spaces" placeholder="Enter text for body" style="margin-bottom:4px; width: 500px;"></span><span>{{ data.bodyObj.last }}</span>
                </div>
                <div v-if="data.turn_template_data && data.turn_template_data.FOOTER" class="nudge-whatsapp-footer">{{data.turn_template_data.FOOTER}}</div>
                <div v-if="data.turn_template_data && data.turn_template_data.BUTTONS" style="margin-top: 5px">
                  <div v-for="(button, bIndex) in data.buttonsObj" :key="'button' + bIndex" class="nudge-whatsapp-button">
                    <template v-if="button.text.length">
                      <span v-for="(part, index) in button.text" :key="'buttonPart' + index">
                        {{ part }}<input v-model="button.gaps[index]" placeholder="Enter value for button link" v-on:keyup="trimMoreThan4Spaces" v-on:blur="trimMoreThan4Spaces" style="width: 300px;">
                      </span>
                      <span>{{ button.last }}</span>
                    </template>
                    <template v-else>{{ button.label }}</template>
                  </div>
                </div>
                <div v-if="!data.turn_template_data" class="nudge-whatsapp-body"> -- Not available in {{turnCountry}} -- </div>
              </div>

              <div class="nudge-origin-title" style="margin-top: 15px">Facebook Nudge(s):</div>
              <div class="margin-bottom-10px" v-for="(data, index) in nudgePreviewData" :key="index">
                <span class="nudge-language">{{data.language}} :</span>
                <div v-if="data.fb_nudge_text" class="nudge-whatsapp-body">{{data.fb_nudge_text}}</div>
                <div v-else class="nudge-whatsapp-body"> -- No data available -- </div>
              </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button v-if="turnCountry" type="button" class="btn btn-primary" @click="saveConfiguredNudgeData">Save</button>
                <button type="button" class="btn btn-primary" @click="closeNudgePreview">Close</button>
              </div>
            </div>
          </div>
      </div>
    </div>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>

  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import * as $ from '../../../static/plugins/jQuery/jquery-2.2.3.min.js'
import messageSet from './messageSet.vue'
import { required, requiredIf, decimal, integer, or, numeric, minValue, maxValue, helpers } from 'vuelidate/lib/validators'
import draggable from 'vuedraggable'
import api from '../../../utils/api'
import { dynamicInputConfig, dataDestinationConfig, stageTypes, contextOptions } from '../conversation/constant'
import moment from 'moment-timezone'
import { referralAppOptions, pfThatRequiresOptionsAutoMagically, digitalVoucherValidationOptions, demographicOptions, locationOptions, bookingStatusOptions, specificReferralTypes, yesNoOptions, insurancePlanOptions, locationTypes, kmDistanceOptions, tagTypes } from './constant'
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import { validateMessageSet } from '../../../utils/utilities'
import NavigateToNextStageBasedOnKeyword from '../processing-functions/pf-navigate-by-keyword.vue'
import MediaPreview from '../common/MediaPreview.vue'

// Regex to validate conversation name contains only alphanumerics, hyphen and underscore
const stageNameRegex = helpers.regex('alpha', /^[a-zA-Z0-9_-]*$/)
Vue.prototype._ = _

export default {
  name: 'app-new-stage',
  props: ['stageDetails', 'isScreening', 'allApps', 'filteredApps', 'filteredAppsForConvos', 'allMethods', 'conversationType', 'screeningMethods', 'isJourneyStage', 'functions', 'embeddedApps', 'allConversations', 'countryAndLanguages', 'metaData', 'currentConvo'],
  validations: {
    ageList: {
      $each: {
        ageLowerLimit: { required, minValue: minValue(0), maxValue: maxValue(99), numeric },
        ageUpperLimit: { required, minValue: minValue(0), maxValue: maxValue(99), numeric }
      }
    },
    functionInput: { required },
    demographicValue: { required },
    stageSelected: { required },
    selectedconversation: { required },
    scoredResponseSelected: { required },
    locationType: { required },
    stagename: { required, stageNameRegex },
    stagetype: { required },
    semanticObj: {
      optionScore: { required: requiredIf(function () {
        return this.stagetype === stageTypes.scoredResponse
      }),
        numberVal: or(integer, decimal)
      },
      tallyLowerLimit: { numeric },
      tallyUpperLimit: { numeric }
    },
    referralValues: { required: requiredIf(function () {
      return this.functionName === 'setImplicitReferrals' && this.referralValues.length === 0
    })},
    selectedReferralType: { required: requiredIf(function () {
      return this.functionName === 'checkUserHaveSpecificReferral' && this.selectedReferralType === null
    })},
    selectedLocationType: { required: requiredIf(function () {
      return this.functionName === 'checkIfResourceExistNearUserLocation'
    })},
    selectedOfferings: { required: requiredIf(function () {
      return this.functionName === 'checkIfResourceExistNearUserLocation'
    })},
    selectedKmDistance: { required: requiredIf(function () {
      return this.functionName === 'checkIfResourceExistNearUserLocation'
    })}

  },
  components: {
    'message-set': messageSet,
    draggable,
    NavigateToNextStageBasedOnKeyword,
    MediaPreview
  },
  async mounted () {
    this.getConversationsList()
    this.getKeywordList()
    this.getNudgesList()
    this.getFbRecurringOptinTopics()
    this.getServicesList()
    this.getMediaList()
    if (this.stageDetails) {
      await this.parseStageDetails(this.stageDetails)
    }
  },
  methods: {
    syncMessageDelayFromConvo (convo) {
      const delay = convo && convo.message_delay_ms
      this.waitBetweenMessages = !!delay
      this.messageDelayMs = delay || 2000
    },
    handleWaitBetweenMessagesToggle () {
      if (this.waitBetweenMessages) {
        this.$set(this.currentConvo, 'message_delay_ms', this.messageDelayMs)
      } else {
        this.$delete(this.currentConvo, 'message_delay_ms')
      }
    },
    handleMessageDelayChange () {
      if (this.waitBetweenMessages && this.isMessageDelayValid) {
        this.$set(this.currentConvo, 'message_delay_ms', this.messageDelayMs)
      }
    },
    handleAddKeywordMapping (newMapping) {
      this.keywordMappingList.push(newMapping)
    },
    validateKeywordMappingList (isValidMapping) {
      console.log('Invoking validations...')
      const isValid = this.$refs.keywordMappingValidationComponent.validate()
      console.log(isValid)
      return isValid
    },
    handleUpdateKeywordConvoMapping (newMapping) {
      this.keywordMappingList = newMapping
      console.log('LatestMapping########################')
      console.log(JSON.stringify(this.keywordMappingList))
    },
    selectAllServices (type) {
      if (type === 'service') {
        if (this.allSelectedServices) {
          this.servicesList.forEach(services => !this.selectedOfferings.includes(services.id) && this.selectedOfferings.push(services.id))
        } else {
          this.selectedOfferings = this.selectedOfferings.filter(item => !this.servicesList.some(service => service.id === item))
        }
      } else if (type === 'product') {
        if (this.allSelectedProducts) {
          this.productList.forEach(services => !this.selectedOfferings.includes(services.id) && this.selectedOfferings.push(services.id))
        } else {
          this.selectedOfferings = this.selectedOfferings.filter(item => !this.productList.some(service => service.id === item))
        }
      }
    },
    selectService (type) {
      setTimeout(() => {
        if (type === 'service') {
          this.allSelectedServices = this.servicesList.every(service => this.selectedOfferings.includes(service.id))
        } else if (type === 'product') {
          this.allSelectedProducts = this.productList.every(service => this.selectedOfferings.includes(service.id))
        }
      })
    },
    async getServicesList () {
      return new Promise(resolve => {
        api.buildRequest('getServicesList', 'POST').then(({ data }) => {
          this.offeringList = data.payload.map(obj => ({...obj, id: String(obj.id)}))
          this.servicesList = this.offeringList.filter(obj => obj.type === 'Service')
          this.productList = this.offeringList.filter(obj => obj.type === 'Product')
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            title: 'Failure',
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    addNudge () {
      this.followupNudges.delays.push({
        quantity: '',
        units: '',
        msg_template_name: ''
      })
    },
    deleteConversation (index) {
      this.followupNudges.delays.splice(index, 1)
    },
    async isMessageSetEdited () {
      if (this.mediatype !== 'uploadedMedia' && this.$refs.messageSet) {
        return await this.$refs.messageSet.isMessageSetEdited()
      }
      return false
    },
    async editEmbeddedConversation () {
      try {
        const response = await api.buildRequest(`fetchAppByName`, 'GET', { name: this.embeddedApp.split('###')[1] })
        let routeData = this.$router.resolve({path: '/conversation/update', query: {app: `${response.data.payload.id}`}})
        window.open(routeData.href, '_blank')
      } catch (error) {
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    handleRecommendationToggle () {
      if (this.toggleSwitchRecommendation) {
        this.showRecommendation = true
      } else {
        this.showRecommendation = false
        this.recommendation = []
      }
    },
    handleConditionalBranchingToggle () {
      if (this.toggleConditionalBranching) {
        this.showConditionalBranching = true
      } else {
        this.showConditionalBranching = false
        this.functionInput = ''
        this.functionName = ''
        this.functionDescription = ''
      }
    },
    changeRedemptionStage () {
      if (this.isRedemptionStage) {
        this.isRedemptionStage = true
      } else {
        this.isRedemptionStage = false
      }
    },
    handleDelayToggle () {
      if (this.toggleSwitchDelay) {
        this.showDelayTactics = true
      } else {
        this.showDelayTactics = false
        this.entries = []
        this.delay = {
          quantity: '',
          units: 'days'
        }
        this.sendTime = {
          hours: '',
          minutes: ''
        }
        this.followupNudges = {
          context: null,
          delays: []
        }
        this.scheduledAppKeyword = null
        this.scheduledKeywordlessConversation = null
        this.msgTemplateName = ''
      }
    },
    resetDelay () {
      this.isInvalidDelay = false
      this.delay = { quantity: '', units: 'days' }
      this.validateTotalTime()
    },
    resetSendTime () {
      this.isInvalidSendTime = false
      this.sendTime = { hours: '', minutes: '' }
      this.validateTotalTime()
    },
    validateScheduledAppKeyword (keyword) {
      if (this.scheduledAppKeyword) {
        this.isInvalidKeywordConversation = false
        if (keyword) {
          const keywordDetails = this.allKeywords.find(item => item.id === keyword)
          this.scheduledAppConversation = keywordDetails ? keywordDetails.conversation_with_country : ''
        }
        this.validateSendTime()
        return false
      } else if (!this.scheduledKeywordlessConversation) {
        this.resetScheduledTime()
        this.followupNudges = {
          context: null,
          delays: []
        }
      }
    },
    validateScheduledKeywordlessConversation () {
      if (this.scheduledKeywordlessConversation) {
        this.isInvalidKeywordConversation = false
        this.validateSendTime()
        return false
      } else if (!this.scheduledAppKeyword) {
        this.resetScheduledTime()
      }
    },
    resetScheduledTime () {
      this.resetDelay()
      this.resetSendTime()
      this.scheduledAppConversation = ''
      this.msgTemplateName = ''
    },
    validateTotalTime () {
      this.isTotalDelay = false
      const durationInMin = 1440
      if (this.delay && this.delay.units && this.delay.quantity && this.sendTime && this.sendTime.hours && this.sendTime.minutes) {
        const totalSendTime = moment.duration(`${this.sendTime.hours}:${this.sendTime.minutes}`).asMinutes()
        let totalDelayTime = 0
        if (this.delay.units === 'hrs') {
          totalDelayTime = moment.duration(Number(this.delay.quantity), 'hours').asMinutes()
        } else if (this.delay.units === 'mins') {
          totalDelayTime = moment.duration(Number(this.delay.quantity), 'minutes').asMinutes()
        } else if (this.delay.units === 'days') {
          totalDelayTime = moment.duration(Number(this.delay.quantity), 'days').asMinutes()
        }
        const totalTime = Number(totalSendTime) + Number(totalDelayTime)
        if (totalTime >= durationInMin) {
          this.isTotalDelay = true
        }
      } else if (this.delay && this.delay.units && this.delay.quantity) {
        let totalDelayTime = 0
        if (this.delay.units === 'hrs') {
          totalDelayTime = moment.duration(Number(this.delay.quantity), 'hours').asMinutes()
        } else if (this.delay.units === 'mins') {
          totalDelayTime = moment.duration(Number(this.delay.quantity), 'minutes').asMinutes()
        } else if (this.delay.units === 'days') {
          totalDelayTime = moment.duration(Number(this.delay.quantity), 'days').asMinutes()
        }
        if (totalDelayTime >= durationInMin) {
          this.isTotalDelay = true
        }
      } else if (this.sendTime && this.sendTime.hours && this.sendTime.minutes) {
        const totalSendTime = moment.duration(`${this.sendTime.hours}:${this.sendTime.minutes}`).asMinutes()
        if (totalSendTime >= durationInMin) {
          this.isTotalDelay = true
        }
      }
    },
    validateDelay (_event) {
      this.delay.quantity = this.delay.quantity.trim()

      let delaypattern = new RegExp('[^0-9]$')
      if (delaypattern.test(this.delay.quantity)) {
        this.delay.quantity = this.delay.quantity.slice(0, -1)
      }

      this.isInvalidDelay = false
      if (!this.delay.quantity) {
        // this.isInvalidDelay = false
        return false
      }
      if (!this.delay.units) {
        this.isInvalidDelay = true
        return true
      } else if (isNaN(this.delay.quantity)) {
        this.isInvalidDelay = true
        return true
      } else if (this.delay.units === 'mins' && Number(this.delay.quantity) < 60) {
        this.isInvalidDelay = true
        return true
      } else if (this.delay.units === 'hrs' && Number(this.delay.quantity) < 1) {
        this.isInvalidDelay = true
        return true
      } else if (this.delay.units === 'days' && Number(this.delay.quantity) < 1) {
        this.isInvalidDelay = true
        return true
      } else if (this.delay.units === 'weeks' && Number(this.delay.quantity) < 1) {
        this.isInvalidDelay = true
        return true
      }
      this.isInvalidSendTime = false
      return false
    },
    // This function is checking if time is invalid.
    validateSendTime (_event) {
      this.sendTime.hours = this.sendTime.hours.trim()
      this.sendTime.minutes = this.sendTime.minutes.trim()
      if (isNaN(this.sendTime.hours.trim())) {
        this.sendTime.hours = ''
      }
      if (isNaN(this.sendTime.minutes.trim())) {
        this.sendTime.minutes = ''
      }
      if (this.sendTime.hours.length > 2) {
        this.isInvalidSendTime = true
        return true
      }
      if (this.sendTime.minutes.length > 2) {
        this.isInvalidSendTime = true
        return true
      }
      this.isInvalidSendTime = false
      if (isNaN(this.sendTime.hours) || isNaN(this.sendTime.minutes)) {
        this.isInvalidSendTime = true
        return true
      } else if (this.sendTime.hours && !this.sendTime.minutes) {
        this.isInvalidSendTime = true
        return true
      } else if (!this.sendTime.hours && this.sendTime.minutes) {
        this.isInvalidSendTime = true
        return true
      } else if (Number(this.sendTime.hours) > 23 || Number(this.sendTime.minutes) > 59) {
        this.isInvalidSendTime = true
        return true
      }
      this.isInvalidDelay = false
      return false
    },
    getStageMetadata () {
      const stageMetaData = {
        stageName: this.stagename
      }
      if (this.inputType) {
        stageMetaData['validations'] = {
          type: this.inputType
        }
        if (this.inputType === 'whatsapp_flows' && this.whatsappFlowId) {
          stageMetaData['whatsappFlowId'] = this.whatsappFlowId
        }
        stageMetaData['input'] = true
        stageMetaData['type'] = 'questions'
      }
      if (this.stagetype) {
        stageMetaData['stageType'] = this.stagetype
      }
      if (this.stagetype !== stageTypes.embeddedConversation && this.mediatype) {
        stageMetaData['mediaType'] = this.mediatype
        delete stageMetaData['conversation']
      }
      if (this.stagetype === stageTypes.embeddedConversation && this.embeddedApp) {
        stageMetaData['conversation'] = this.embeddedApp
        delete stageMetaData['mediaType']
      }
      if (this.isRedemptionStage) {
        stageMetaData['isRedemptionStage'] = this.isRedemptionStage
      }

      return stageMetaData
    },
    getOptionsNextStageSemanticData () {
      const stageOptionsData = {}

      if (this.options) {
        stageOptionsData['options'] = this.options.split(/,\s*/)
        stageOptionsData['options'] = stageOptionsData['options'].filter(function (e) { return e === 0 || e })
      }
      if (this.inputType === 'Boolean') {
        // then overwrite options and assign it to [true, false]
        stageOptionsData['options'] = [true, false]
      }
      if (this.semantic && this.stagetype !== stageTypes.scoreRanking) {
        stageOptionsData['semantic'] = this.semantic
      }
      if (this.nextStages) {
        let stages = this.nextStages.split(/,\s*/)
        stages = stages.filter(function (e) { return e === 0 || e })
        stageOptionsData['next'] = stages.length > 1 ? stages : stages[0]
      }
      return stageOptionsData
    },
    removeEmptyHeaderBodyForDynamicTempalte (dynamicValueConfiguration) {
      if (dynamicValueConfiguration) {
        for (const lang of Object.keys(dynamicValueConfiguration)) {
          if (dynamicValueConfiguration[lang].header && dynamicValueConfiguration[lang].header.length === 0) delete dynamicValueConfiguration[lang].header
          if (dynamicValueConfiguration[lang].body && dynamicValueConfiguration[lang].body.length === 0) delete dynamicValueConfiguration[lang].body
          if (dynamicValueConfiguration[lang].buttons && dynamicValueConfiguration[lang].buttons.every(gaps => !gaps || gaps.length === 0)) delete dynamicValueConfiguration[lang].buttons
        }
        return dynamicValueConfiguration
      } else return {}
    },
    async getCurrentStage () {
      let stage = {}
      stage = {...this.getStageMetadata()}
      stage = {...stage, ...this.getOptionsNextStageSemanticData()}
      if (this.mediatype !== 'uploadedMedia' && this.stagetype !== stageTypes.embeddedConversation && this.stagetype !== stageTypes.fbOptIn && this.stagetype !== stageTypes.journeyReminder) {
        if (this.rankingScores && this.stagetype === stageTypes.scoreRanking) {
          stage['rankingScores'] = this.rankingScores
          delete stage['input']
          delete stage['validations']
        }
        if (this.optionScores && this.stagetype === stageTypes.scoredResponse) {
          stage['optionScores'] = this.optionScores
        }
        if (this.optionConfig && this.optionConfig.length) {
          stage['optionConfig'] = this.optionConfig
        }
        if (this.functionName || this.functionInput) {
          stage['processingFunctionConfig'] = {
            'functionName': this.functionName,
            'inputConfig': this.functionInput
          }
        }
        if (this.showMethodsTable) {
          stage['methods'] = this.methods
        }
        if (this.nextApp) {
          stage['nextApp'] = this.nextApp
        }
        if (this.failed) {
          stage['failed'] = this.failed
        }
        if (this.recommendation) {
          stage['recommendation'] = this.recommendation || []
        }
        if (this.tags) {
          stage['tags'] = this.tags || []
        }
        if (this.subsequentApp) {
          stage['subsequentApp'] = this.subsequentApp
        }
        if (this.referralType) {
          stage['referralType'] = this.referralType
        }
        if (this.additionalReferralConfig && Object.keys(this.additionalReferralConfig).some(key => this.additionalReferralConfig[key])) {
          stage['additionalReferralConfig'] = Object.fromEntries(
            Object.entries(this.additionalReferralConfig).filter(
              ([_, value]) => Boolean(value)
            )
          )
        }
        if (this.notification) {
          stage.notification = this.notification
        }

        // Below data "MIGHT" be invalid for saving stage but according to flow, we are going to validate it in isValidCurrentStage.
        // This function getCurrentStage() only returns current field values as stage. Validations should be separate

        if (this.entries.length) {
          stage['scheduledAppKeyword'] = []
          this.entries.forEach(entry => {
            if (!entry.isInvalidKeywordConversation) {
              if (entry.scheduledAppKeyword) {
                const keyword = this.allKeywords.find(item => {
                  return item.id === entry.scheduledAppKeyword
                })
                const keywordName = keyword ? keyword.keyword : ''
                stage.scheduledAppKeyword.push(keywordName)
              } else {
                stage.scheduledAppKeyword.push(`conversationkeyword:${entry.scheduledKeywordlessConversation}`)
              }
            }
          })

          if (this.delay && this.delay.quantity) {
            this.delay.quantity = this.delay.quantity.padStart(2, '0')
            stage['delay'] = {...this.delay} || { quantity: '', units: 'days' }
          }
          if (this.sendTime && this.sendTime.hours && this.sendTime.minutes) {
            this.sendTime.hours = this.sendTime.hours.padStart(2, '0')
            this.sendTime.minutes = this.sendTime.minutes.padStart(2, '0')
            stage['sendTime'] = {...this.sendTime} || { hours: '', minutes: '' }
          }
          stage['msgTemplateName'] = this.msgTemplateName || ''
          stage['dynamic_value_configuration'] = this.removeEmptyHeaderBodyForDynamicTempalte(this.dynamic_value_configuration)
          if (this.followupNudges && this.followupNudges.context) {
            this.followupNudges.delays = this.followupNudges.delays.filter(item => (item.msg_template_name !== '' || item.quantity !== '' || item.units !== '')).map(item => {
              return {
                ...item,
                dynamic_value_configuration: this.removeEmptyHeaderBodyForDynamicTempalte(item.dynamic_value_configuration)
              }
            })
            stage.followupNudges = this.followupNudges
          }
        } else {
          delete stage['scheduledAppKeyword']
          delete stage['scheduledAppConversation']
          delete stage['delay']
          delete stage['sendTime']
          delete stage['msgTemplateName']
          delete stage['dynamic_value_configuration']
          delete stage['followupNudges']
        }

        const text = await this.$refs.messageSet.getParsedMessageSet()
        stage = {...stage, text}
      } else {
        delete stage['rankingScores']
        delete stage['optionScores']
        delete stage['optionConfig']
        delete stage['processingFunctionConfig']
        delete stage['methods']
        delete stage['nextApp']
        delete stage['failed']
        delete stage['recommendation']
        delete stage['tags']
        delete stage['subsequentApp']
        delete stage['referralType']
        delete stage['additionalReferralConfig']
        delete stage['topic']
        delete stage['frequency']
        delete stage['joRDelayConfig']
        delete stage['jorTemplateName']
        delete stage['dynamic_value_configuration']

        if (!stage['text']) stage['text'] = []
        if (this.referralType) {
          stage['referralType'] = this.referralType
        }
        if (this.additionalReferralConfig && Object.keys(this.additionalReferralConfig).some(key => this.additionalReferralConfig[key])) {
          stage['additionalReferralConfig'] = Object.fromEntries(
            Object.entries(this.additionalReferralConfig).filter(
              ([_, value]) => Boolean(value)
            )
          )
        }
      }
      if (this.stageDetails.questionId) {
        stage.questionId = this.stageDetails.questionId
      }

      if (this.stagetype === stageTypes.journeyReminder) {
        stage.jorTemplateName = this.msgTemplateName
        stage.dynamic_value_configuration = this.removeEmptyHeaderBodyForDynamicTempalte(this.dynamic_value_configuration)
        stage['joRDelayConfig'] = {}
        if (this.delay && this.delay.quantity) {
          this.delay.quantity = this.delay.quantity.padStart(2, '0')
          stage['joRDelayConfig']['delay'] = {...this.delay} || { quantity: '', units: 'days' }
        }
        if (this.sendTime && this.sendTime.hours && this.sendTime.minutes) {
          this.sendTime.hours = this.sendTime.hours.padStart(2, '0')
          this.sendTime.minutes = this.sendTime.minutes.padStart(2, '0')
          stage['joRDelayConfig']['sendTime'] = {...this.sendTime} || { hours: '', minutes: '' }
        }
      } else if (this.stagetype === stageTypes.fbOptIn) {
        stage['text'] = await this.$refs.messageSet.getParsedMessageSet()
        stage['topic'] = this.topicList.find(item => item.id === this.topic) && this.topicList.find(item => item.id === this.topic).value
        stage['frequency'] = this.frequency
      } else if (this.mediatype === 'uploadedMedia') {
        console.log('this.media: ', this.uploadedMedia)
        stage['media'] = this.uploadedMedia
      }

      console.log('stage: ', stage)
      return stage
    },
    scrollToElement (el) {
      if (el) {
        el.scrollIntoView({behavior: 'smooth'})
      }
    },
    async isValidStageSettings (stage) {
      if (((stage['optionScores'] && this.semanticData.length !== Object.keys(stage['optionScores']).length) ||
      (this.semanticData.length > 0 && _.isEmpty(stage['optionScores']))) && stage['stageType'] === stageTypes.scoredResponse) {
        this.errorMessage = 'Option score cannot be null'
        if (this.semanticData.length > 1 && (!stage['options'] || stage['options'].length < Object.keys(stage['optionScores']).length)) {
          this.errorMessage = 'Option name is required when multiple stages are specified'
        }
        this.showValidationError = true
        this.scrollToElement(this.$refs.errorDiv)
        return false
      }
      if (!this.nextApp && this.semanticData.length === 0) {
        this.errorMessage = this.stagetype === stageTypes.traditional ? 'Next Stage or Next App is mandatory' : 'Next Stage is mandatory'
        this.showValidationError = true
        this.scrollToElement(this.$refs.errorDiv)
        return false
      }
      if (this.nextApp && this.semanticData.length) {
        this.errorMessage = 'Please select only Next Stage or Next App'
        this.showValidationError = true
        this.scrollToElement(this.$refs.errorDiv)
        return false
      }
      if (this.semanticData.length > 1 && stage['options'] && this.semanticData.length !== stage['options'].length) {
        this.errorMessage = 'Option name is required when multiple stages are specified'
        this.showValidationError = true
        this.scrollToElement(this.$refs.errorDiv)
        return false
      }
      if (stage && this.inputType !== 'DynamicNumber' && stage.next) {
        if (typeof stage.next === 'string') {
          if (stage.stageName === stage.next) {
            this.errorMessage = `The current stage name and the next stage name cannot be the same`
            this.showValidationError = true
            return false
          }
        } else if (typeof stage.next === 'object') {
          if (stage.next.includes(stage.stageName)) {
            this.errorMessage = `The current stage name and the next stage name cannot be the same`
            this.showValidationError = true
            return false
          }
        }
      }

      if (stage && this.inputType === 'nlpDecision') {
        if (!this.currentConvo.topic_id) {
          this.$swal({
            type: 'error',
            text: 'Input type NLP Decision is only available when the Topic is selected'
          })
          return false
        }
      }

      // Conversation 1.1 validation for funtions in journey conversation
      if (this.functionName && (!this.semanticData.length || !(stage['options'] && stage['options'].length))) {
        this.errorMessage = `Please configure at least 1 option + next stage ${this.isDefaultRequired ? 'and a default option + next stage' : ''}`
        this.showValidationError = true
        this.scrollToElement(this.$refs.errorDiv)
        return false
      } else {
        if (stage['options'] && stage['options'].length && this.functionName && this.stagetype === stageTypes.traditional) {
          if (this.isDefaultRequired) {
            if (!stage['options'].includes('default')) {
              this.errorMessage = 'Please configure a default (fallback) option with a next stage'
              this.showValidationError = true
              this.scrollToElement(this.$refs.errorDiv)
              return false
            } else if (stage['options'] && stage['options'].length === 1) {
              this.errorMessage = 'Please configure one more option + next stage'
              this.showValidationError = true
              this.scrollToElement(this.$refs.errorDiv)
              return false
            }
          }
        }
      }

      // Mandatory next app/stage validation
      if (!this.nextApp && this.semanticData.length > 0) {
        if (stage['next']) {
          if ((typeof stage['next'] === 'string' && this.semanticData.length !== 1) || (typeof stage['next'] !== 'string' && this.semanticData.length !== stage['next'].length)) {
            this.errorMessage = this.stagetype === stageTypes.traditional ? 'Next stage is required when Next App is not specified' : 'Next Stage is mandatory'
            this.showValidationError = true
            this.scrollToElement(this.$refs.errorDiv)
            return false
          }
        } else {
          this.errorMessage = this.stagetype === stageTypes.traditional ? 'Next stage is required when Next App is not specified' : 'Next Stage is mandatory'
          this.showValidationError = true
          this.scrollToElement(this.$refs.errorDiv)
          return false
        }
      }

      // Scheduled app keyword validation

      if (this.showDelayTactics) {
        if (this.entries.length) {
          this.entries.forEach(entry => {
            if (!(entry.scheduledAppKeyword || entry.scheduledKeywordlessConversation)) {
              entry.isInvalidKeywordConversation = true
              return false
            }
          })
        }

        let nudgeTemplateList = []
        if (this.msgTemplateName) {
          nudgeTemplateList.push(this.msgTemplateName)
        }
        this.followupNudges.delays.forEach(nudge => {
          if (nudge.msg_template_name) {
            nudgeTemplateList.push(nudge.msg_template_name)
          }
        })
        const queryString = nudgeTemplateList.map(template => `nudgeList=${encodeURIComponent(template)}`).join('&')
        await this.getTurnCountryList()
        const response = await api.buildRequest(`getNudgeButtonCount?${queryString}`, 'GET', { country: this.turnCountry })

        const isButtonCountUniform = response.data.payload.isButtonCountUniformAcrossTemplates

        if (!isButtonCountUniform) {
          this.$swal({
            type: 'error',
            text: 'Button Count should be uniform across all the message templates'
          })
          return false
        }

        if (this.delay.quantity) {
          this.isInvalidDelay = false
        } else if (this.sendTime.hours && this.sendTime.minutes) {
          this.isInvalidSendTime = false
        } else {
          this.isInvalidDelay = true
          this.isInvalidSendTime = true
          return false
        }
        if (this.msgTemplateName && !this.checkIfNudgeConfigurationValid({dynamic_value_configuration: this.dynamic_value_configuration, msg_template_name: this.msgTemplateName})) {
          this.isInvalidMessageTemplate = true
          return false
        }

        if (this.validateDelay()) {
          return false
        }
        if (this.validateSendTime()) {
          return false
        }
        if (this.followupNudges.context && this.followupNudges.delays.length) {
          let showErr = false
          this.followupNudges.delays.forEach(nudge => {
            if (nudge.quantity || nudge.units || nudge.msg_template_name) {
              if (!(nudge.quantity && nudge.units && (nudge.msg_template_name || this.scheduledAppKeyword === 'journey_pause'))) {
                showErr = true
              } else if ((nudge.units === 'hrs' && nudge.quantity < 24) || (nudge.units === 'days' && nudge.quantity < 1)) {
                showErr = true
              }
            }
            if (nudge.msg_template_name && !this.checkIfNudgeConfigurationValid(nudge)) {
              showErr = true
            }
          })
          if (showErr) {
            this.showValidationError = true
            this.scrollToElement(this.$refs.nudgeDiv)
            return false
          }
        }
        if (this.msgTemplateName || this.scheduledAppKeyword === -1) {
          this.isInvalidMessageTemplate = false
        } else {
          this.isInvalidMessageTemplate = true
          return false
        }
      }

      if (this.scheduledAppKeyword || this.scheduledKeywordlessConversation) {
        if (this.scheduledAppKeyword) {
          if (this.validateScheduledAppKeyword()) {
            return false
          }
        }
      }

      // Validations for Journey of reminders
      if (this.stagetype === stageTypes.journeyReminder) {
        if (this.delay.quantity) {
          this.isInvalidDelay = false
        } else if (this.sendTime.hours && this.sendTime.minutes) {
          this.isInvalidSendTime = false
        } else {
          this.isInvalidDelay = true
          this.isInvalidSendTime = true
          return false
        }
        if (this.msgTemplateName && !this.checkIfNudgeConfigurationValid({dynamic_value_configuration: this.dynamic_value_configuration, msg_template_name: this.msgTemplateName})) {
          return false
        }
        if (!this.msgTemplateName) {
          this.isInvalidMessageTemplate = true
          return false
        }
        if (this.validateDelay()) {
          return false
        }
        if (this.validateSendTime()) {
          return false
        }
      }

      // Validations for embedded stage
      if (this.stagetype === stageTypes.embeddedConversation) {
        if (this.conversationNotExistError) return false
        if (this.embeddedApp && stage['next'] && typeof stage['next'] === 'string') {
          stage['conversation'] = this.embeddedApp
          stage['text'] = []
        } else {
          if (!this.embeddedApp) {
            this.showValidationError = true
            this.scrollToElement(this.$refs.errorDiv)
          }
          if (!stage['next']) {
            this.errorMessage = 'Please provide one stage to which app will redirect after conversation'
            this.showValidationError = true
            this.scrollToElement(this.$refs.errorDiv)
          } else if (stage['next'].length > 1) {
            this.errorMessage = 'Maximum one stage is allowed for embedded apps stage'
            this.showValidationError = true
            this.scrollToElement(this.$refs.errorDiv)
          }
          return false
        }
      }

      // Validations for fb optin stage
      if (this.stagetype === stageTypes.fbOptIn) {
        if (!this.topic || !this.frequency) {
          this.showValidationError = true
          this.scrollToElement(this.$refs.errorDiv)
          return false
        }
      }

      let {resp, error} = validateMessageSet(stage)
      if (!resp && error) {
        this.$swal(error)
        return false
      }

      return true
    },
    async isValidCurrentStage (stage) {
      this.loading = true
      const validStageSettings = await this.isValidStageSettings(stage)
      this.loading = false
      if (!validStageSettings) {
        $('#content-stage-settings').removeClass('in')
        $('#content-stage-settings').addClass('in')
        $('#content-stage-settings').css('height', '')
        $('a[href="#content-stage-settings"]').removeClass('collapsed')
      }
      return validStageSettings
    },
    /**
     * @function addOrUpdateStage
     * @description Add or Update Stage for the conversation
     */
    async addOrUpdateStage (isValidateJourney, isDeployClicked = false, isReleaseClicked = false) {
      this.submitted = true
      this.showValidationError = false
      this.errorMessage = ''
      this.methodTypeModificationRequired = false
      this.$v.$touch()
      if (this.$v.stagetype.$invalid || this.$v.stagename.$invalid) {
        return
      }
      if (this.disableStageName && this.waitBetweenMessages && !this.isMessageDelayValid) {
        return
      }
      if (this.stagetype !== stageTypes.embeddedConversation && this.stagetype !== stageTypes.journeyReminder && this.mediatype !== 'uploadedMedia') {
        const isMessageSetValid = await this.$refs.messageSet.validMessages()
        if (!isMessageSetValid) return
      }
      const stage = await this.getCurrentStage()
      const isValidCurrentStage = await this.isValidCurrentStage(stage)
      if (isValidCurrentStage) {
        if (this.editedStage !== this.stagename) {
          this.$emit('replace', stage, this.editedStage, this.stagename, isValidateJourney, isDeployClicked, isReleaseClicked)
        } else {
          this.$emit('addStage', stage, this.stagename, isValidateJourney, isDeployClicked, isReleaseClicked)
          this.editedStage = ''
        }
      }
    },
    resetValues () {
      const fields = ['stagename', 'options', 'nextStages', 'inputType', 'failed', 'notification', 'nextApp', 'subsequentApp']
      fields.forEach(each => {
        this[each] = ''
      })
      this.nextApp = null
      this.subsequentApp = null
      this.allMessages = []
      this.methods = {}
      this.submitted = false
      this.semantic = []
      this.semanticData = []
      this.recommendation = []
      this.tags = []
      this.entries = []
      this.delay = {
        quantity: '',
        units: 'days'
      }
      this.dynamic_value_configuration = {}
      this.sendTime = {
        hours: '',
        minutes: ''
      }
      this.scheduledAppKeyword = null
      this.scheduledKeywordlessConversation = null
      this.scheduledAppConversation = ''
      this.msgTemplateName = ''
      this.optionConfig = []
      this.showRecommendation = false
      this.showDelayTactics = false
      this.showConditionalBranching = false
      this.toggleSwitchRecommendation = false
      this.toggleConditionalBranching = false
      this.toggleSwitchDelay = false
      this.functionInput = ''
      this.functionName = ''
      this.functionDescription = ''
      this.isRedemptionStage = false
      this.whatsappFlowId = ''
    },

    /**
      @description used to add or rule out methods based on users' response
    */
    addOrRemoveMethod () {
      this.frmAddRemoveMethodSubmitted = false
      if (!this.methodTypeModification) {
        this.frmAddRemoveMethodSubmitted = true
        this.methodTypeModificationRequired = true
        return
      }
      this.$set(this.methods, this.methodOption, {type: this.methodTypeModification, methods: this.choosenMethods})
    },

    /**
      @description remove a method option details
      @param {string} option -
    */
    deleteMethodOption (option, methods) {
      this.$delete(this.methods, option)
    },

    searchValueInArray (val, myArray) {
      let result = {
        isValExists: false,
        index: -1
      }
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].id === val) {
          result.isValExists = true
          result.index = i
          return result
        }
      }
      return result
    },

    getDescription () {
      this.submitted = false
      this.functionInput = ''
      this.demographicValue = null
      this.selectedconversation = null
      this.stageSelected = null
      this.scoredResponseSelected = null
      this.locationType = ''
      this.optionDisplayArr = []
      this.referralValues = []
      if (!this.functionName) {
        this.functionDescription = ''
        this.isInputRequired = false
        this.isDefaultRequired = false
        return
      }
      if (this.functions.length) {
        const data = this.functions.filter(f => f.function_name === this.functionName)
        if (data.length > 0) {
          this.functionDescription = data[0].description
          this.isInputRequired = data[0].is_input_required
          this.isDefaultRequired = data[0].is_default_required
        }
      }
      if (this.functionName === 'setImplicitReferrals' && this.stageDetails.processingFunctionConfig && this.stageDetails.processingFunctionConfig.inputConfig) {
        this.stageDetails.processingFunctionConfig.inputConfig.forEach((referral) => {
          this.referralValues.push(referral.id)
        })
      }
    },
    getProcessingFunctionAlias (functionName) {
      if (this.functions.length) {
        const data = this.functions.filter(f => f.function_name === functionName)
        if (data.length > 0) {
          this.functionAlias = data[0].alias
        } else {
          this.functionAlias = ''
        }
      }
    },
    setContextOption () {
      if (!this.followupNudges.context) {
        this.followupNudges.delays = []
      }
    },
    setOptions  (isInputTypeChanged = false) {
      if ([this.nextApp, this.subsequentApp, this.embeddedApp].includes('APP_UNIFIED_REFERRAL')) {
        if (!this.referralType) this.referralType = 'PHYSICAL_LOADMORE_THEN_VIRTUAL'
      } else {
        this.additionalReferralConfig = {
          showPhysicalResouceAsPerPubliCPrivateSelection: false
        }
        this.referralType = null
      }
      console.log('After setOptions: ', this.nextApp, this.subsequentApp, this.referralType)
      if (this.nextApp && this.subsequentAppEnabledFor.indexOf(this.nextApp) !== -1) {
        const filteredAppArr = this.filteredApps
        const searchResult = this.searchValueInArray('APP_UNIFIED_REFERRAL', filteredAppArr)
        const isUnifiedReferralAppExists = searchResult.isValExists
        if (this.nextApp !== 'APP_LOCATION') {
          if (isUnifiedReferralAppExists) {
            this.filteredApps = this.filteredApps.filter(app => app.id !== 'APP_UNIFIED_REFERRAL')
          }
        } else {
          if (!isUnifiedReferralAppExists) {
            this.filteredApps.push({ label: 'Unified Referral', id: 'APP_UNIFIED_REFERRAL' })
          }
        }
        this.isDisabledSubsequentApp = false
      } else {
        this.subsequentApp = null
        this.isDisabledSubsequentApp = true
      }
      if (this.inputType === 'Boolean') {
        this.options = 'true, false'
      }
      this.draggable = true
      if (this.inputType === 'Boolean') {
        this.draggable = false
      }

      if (isInputTypeChanged && this.inputType === 'DynamicNumber' && !this.options.includes('null_list')) {
        if (this.options !== '') {
          this.options += ', null_list'
        } else {
          this.options += 'null_list'
        }

        if (this.nextStages !== '') {
          this.nextStages += ', null_list'
        } else {
          this.nextStages += 'null_list'
        }
      }
      this.parseSemanticData()
    },
    getNudgesList () {
      api.buildRequest(`reengagement/nudges`, 'POST').then(({ data }) => {
        this.nudgesList = data.payload
      })
    },
    getMediaList () {
      api.buildRequest('getAllMediaList', 'GET').then(({ data }) => {
        this.mediaList = data.payload.map(media => { return { id: media.media_name, label: media.media_name } })
        // The full rows, by name (the stage stores the name), for the selected-media preview.
        this.mediaByName = data.payload.reduce((map, media) => { map[media.media_name] = media; return map }, {})
      })
    },
    getKeywordList () {
      api.buildRequest('getKeywordList', 'GET').then(({ data }) => {
        console.log('KW...............', data.payload[0])
        this.allKeywords = data.payload.map(keyword => { return { id: keyword.keyword, keyword: keyword.keyword, label: keyword.keyword_with_country, conversation_with_country: keyword.conversation_with_country, conversation_id: keyword.conversation_id, keyword_id: keyword.keyword_id } })
        console.log('AllKW: ', this.allKeywords[0])
        this.allKeywords.unshift({id: 'journey_pause', label: 'journey_pause', keyword: 'journey_pause'})
      })
    },
    async getReferralResources (searchQuery) {
      return api.buildRequest('getReferralResources', 'POST', {'query': searchQuery})
      .then(response => {
        let resources = response.data.payload
        let options = []
        resources.forEach(resource => {
          if (resource.full_name) options.push({id: resource.id, label: resource.full_name})
        })
        return options
      })
    },
    async loadOptions ({ action, searchQuery, callback }) {
      if (!searchQuery) {
        this.initialReferralsList = await this.getReferralResources()
        this.referralValues = []
        if (this.pfStoredReferralsList.length > 0) {
          this.initialReferralsList.forEach((referral) => {
            this.pfStoredReferralsList.forEach((value) => {
              if (referral.id === value.id) {
                this.referralValues.push(referral.id)
              }
            })
          })
          if (this.referralValues.length !== this.pfStoredReferralsList.length) {
            this.pfStoredReferralsList.forEach((value) => {
              if (!this.referralValues.includes(value.id)) {
                this.initialReferralsList.push({id: value.id, label: value.name})
                this.referralValues.push(value.id)
              }
            })
          }
        }
        callback(null, this.initialReferralsList)
      }
      if (action === ASYNC_SEARCH && searchQuery.length > 3) {
        let options = await this.getReferralResources(searchQuery)
        callback(null, options)
      }
      if (searchQuery && searchQuery.length < 4) {
        let options = []
        this.initialReferralsList.forEach(resource => {
          if (resource.label.toLowerCase().includes(searchQuery.toLowerCase())) {
            options.push(resource)
          }
        })
        callback(null, options)
      }
    },
    getFbRecurringOptinTopics () {
      api.buildRequest('getFbRecurringOptinTopics', 'GET').then(({ data }) => {
        this.topicList = data.payload.map(topic => { return { id: topic.title, label: topic.title, value: {title: topic.title, payload: topic.payload} } })
      })
    },
    closeNudgePreview () {
      if (this.isEditedNudgeDynamic) {
        this.selectedDynamicNudgeData.dynamic_value_configuration = this.currentDynamicNudgeValue
      } else {
        this.dynamic_value_configuration = this.currentDynamicNudgeValue
      }
      this.showNudgePreview = false
      this.lastNudgePreviewArgs = null
    },
    saveConfiguredNudgeData () {
      if (!this.checkIfNudgeConfigurationValid(this.selectedDynamicNudgeData)) {
        this.$swal({
          type: 'error',
          text: 'Please enter data in all the fields'
        })
        return
      }
      let lengthExceedErrors = []
      this.nudgePreviewData.forEach(nudge => {
        let header = nudge.headerObj.content
        nudge.headerObj.gaps && nudge.headerObj.gaps.forEach(gap => {
          header = header.replace(/{{(.+?)}}/, gap)
        })
        if (header && header.length > 60) {
          lengthExceedErrors.push(`Header length should not exceed the total limit of 60 characters for ${nudge.language}`)
        }

        let body = nudge.bodyObj.content
        nudge.bodyObj.gaps && nudge.bodyObj.gaps.forEach(gap => {
          body = body.replace(/{{(.+?)}}/, gap)
        })
        if (body && body.length > 1024) {
          lengthExceedErrors.push(`Body length should not exceed the total limit of 1024 characters for ${nudge.language}`)
        }

        nudge.buttonsObj && nudge.buttonsObj.forEach((buttonObj, bIndex) => {
          let url = buttonObj.content
          if (!url) return
          buttonObj.gaps && buttonObj.gaps.forEach(gap => {
            url = url.replace(/{{(.+?)}}/, gap)
          })
          if (url.length > 2000) {
            lengthExceedErrors.push(`Button ${bIndex + 1} URL length should not exceed the total limit of 2000 characters for ${nudge.language}`)
          }
        })
      })
      if (lengthExceedErrors.length) {
        this.$swal({
          type: 'error',
          text: lengthExceedErrors.join('\n')
        })
        return
      }
      this.showNudgePreview = false
    },
    trimMoreThan4Spaces (event) {
      const regex = /\s{5,}/g
      const replacement = '    ' // 4 spaces
      event.target.value = event.target.value.replace(regex, replacement)
    },
    isDynamicTemplate (nudgeId, nudgeName = '') {
      if (nudgeName) {
        const nudgeData = this.nudgesList.find(item => item.msg_template_name === nudgeName)
        return nudgeData && nudgeData.is_dynamic_template
      } else {
        const nudgeData = this.nudgesList.find(item => item.id === nudgeId)
        return nudgeData && nudgeData.is_dynamic_template
      }
    },
    // Grows/shrinks a shared gaps array in place to match the current template's
    // placeholder count, without losing the values already entered by the user.
    resizeGapsInPlace (gaps, length) {
      while (gaps.length < length) gaps.push('')
      gaps.length = length
    },
    checkIfNudgeConfigurationValid (group) {
      if (this.isDynamicTemplate('', group.msg_template_name)) {
        if (!group.dynamic_value_configuration || Object.keys(group.dynamic_value_configuration).length === 0) return false
        for (const contentData of Object.values(group.dynamic_value_configuration)) {
          for (const tokens of Object.values(contentData)) {
            // "buttons" is an array of per-button gap arrays, so flatten it before checking
            for (let item of tokens.flat()) {
              if (!item) return false
            }
          }
        }
      }
      return true
    },
    /**
     * @description WhatsApp countries configured for this instance. A conversation is not
     * tied to one country, so the preview popup asks for it before loading templates.
     */
    async getTurnCountryList () {
      if (this.turnCountryList.length) return
      try {
        const response = await api.buildRequest('getQuickLinkConfig', 'POST')
        const whatsapp = (response.data.payload && response.data.payload.whatsapp) || {}
        const allCountries = Object.keys(whatsapp)
        // Prefer the countries this conversation is configured for, when they have a Turn account
        const conversationCountries = allCountries.filter(country => (this.countryAndLanguages || {})[country])
        this.turnCountryList = conversationCountries.length ? conversationCountries : allCountries
      } catch (error) {
        console.error('Failed to fetch WhatsApp country list', error)
      }
    },
    onTurnCountryChange () {
      if (this.turnCountry) {
        this.showCountryPicker = false
        if (this.lastNudgePreviewArgs) this.loadNudgePreview()
      }
    },
    /**
     * @description opens the preview/configure popup on the country picked earlier while
     * editing this conversation, and asks for one when there is no usable choice yet. The
     * country is kept in component state only, so it resets on a page change or refresh.
     */
    async onNudgePreviewClick (nudgeName, passByRef, isDynamicList = false) {
      this.lastNudgePreviewArgs = [nudgeName, passByRef, isDynamicList]
      this.nudgePreviewData = []
      this.selectedDynamicNudgeData = passByRef
      this.isEditedNudgeDynamic = isDynamicList
      // Keep the current dynamic values so closing without picking a country restores them unchanged
      this.currentDynamicNudgeValue = passByRef.dynamic_value_configuration
        ? JSON.parse(JSON.stringify(passByRef.dynamic_value_configuration))
        : passByRef.dynamic_value_configuration
      this.loading = true
      await this.getTurnCountryList()
      if (!this.turnCountryList.includes(this.turnCountry)) this.turnCountry = ''
      this.showCountryPicker = !this.turnCountry
      this.loading = false
      this.showNudgePreview = true
      if (this.turnCountry) this.loadNudgePreview()
    },
    async loadNudgePreview () {
      const [nudgeName, passByRef, isDynamicList] = this.lastNudgePreviewArgs
      try {
        this.loading = true
        const response = await api.buildRequest(`getNudgePreview`, 'GET', { nudge: nudgeName, country: this.turnCountry })
        this.showNudgePreview = true

        // Assigning value to passByRef was not working in case of not using direct object so passed one more flag to check isDynamicList
        this.selectedDynamicNudgeData = passByRef
        this.isEditedNudgeDynamic = isDynamicList
        let reg = /\{\{.*?\}\}/g
        if (this.isDynamicTemplate('', nudgeName) && (!passByRef.dynamic_value_configuration)) {
          passByRef.dynamic_value_configuration = {}
        }

        response.data.payload.forEach(item => {
          const turnTemplateData = item.turn_template_data || {}
          item.headerObj = {
            content: turnTemplateData.HEADER,
            gaps: [],
            text: [],
            last: ''
          }
          if (item.is_dynamic_template && turnTemplateData.HEADER) {
            let text = turnTemplateData.HEADER.split(reg)
            item.headerObj.last = text.pop()
            text.forEach((part, i) => {
              item.headerObj.gaps.push('')
            })
            item.headerObj.text = text
          } else {
            item.headerObj.last = turnTemplateData.HEADER
          }

          item.bodyObj = {
            content: (turnTemplateData.BODY || '').trim(),
            gaps: [],
            text: [],
            last: ''
          }
          if (item.is_dynamic_template && turnTemplateData.BODY) {
            let text = turnTemplateData.BODY.trim().split(reg)
            item.bodyObj.last = text.pop()
            text.forEach((part, i) => {
              item.bodyObj.gaps.push('')
            })
            item.bodyObj.text = text
          } else {
            item.bodyObj.last = turnTemplateData.BODY
          }

          // A button (e.g. a URL button) can also carry a dynamic {{n}} token, not just header/body.
          item.buttonsObj = (turnTemplateData.BUTTONS || []).map(button => {
            const buttonObj = {
              label: button && button.text,
              content: button && button.url,
              gaps: [],
              text: [],
              last: button && button.text
            }
            if (item.is_dynamic_template && button && button.type === 'URL' && button.url) {
              let text = button.url.split(reg)
              buttonObj.last = text.pop()
              text.forEach((part, i) => {
                buttonObj.gaps.push('')
              })
              buttonObj.text = text
            }
            return buttonObj
          })

          if (passByRef.dynamic_value_configuration[item.lang]) {
            const savedConfig = passByRef.dynamic_value_configuration[item.lang]
            // Reuse the same array (not a copy) so editing the value for one country's
            // preview updates it for every other country too - it's one shared value.
            if (!Array.isArray(savedConfig.header)) savedConfig.header = item.headerObj.gaps
            this.resizeGapsInPlace(savedConfig.header, item.headerObj.text.length)
            item.headerObj.gaps = savedConfig.header

            if (!Array.isArray(savedConfig.body)) savedConfig.body = item.bodyObj.gaps
            this.resizeGapsInPlace(savedConfig.body, item.bodyObj.text.length)
            item.bodyObj.gaps = savedConfig.body

            if (!Array.isArray(savedConfig.buttons)) savedConfig.buttons = item.buttonsObj.map(buttonObj => buttonObj.gaps)
            item.buttonsObj.forEach((buttonObj, bIndex) => {
              if (!Array.isArray(savedConfig.buttons[bIndex])) savedConfig.buttons[bIndex] = buttonObj.gaps
              this.resizeGapsInPlace(savedConfig.buttons[bIndex], buttonObj.text.length)
              buttonObj.gaps = savedConfig.buttons[bIndex]
            })
          } else {
            passByRef.dynamic_value_configuration[item.lang] = {}
            passByRef.dynamic_value_configuration[item.lang].header = item.headerObj.gaps
            passByRef.dynamic_value_configuration[item.lang].body = item.bodyObj.gaps
            passByRef.dynamic_value_configuration[item.lang].buttons = item.buttonsObj.map(buttonObj => buttonObj.gaps)
          }
        })

        this.currentDynamicNudgeValue = JSON.parse(JSON.stringify(passByRef.dynamic_value_configuration))
        this.nudgePreviewData = response.data.payload
        this.loading = false
      } catch (error) {
        console.log(error)
        this.nudgePreviewData = []
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async onTemplateChange () {
      this.dynamic_value_configuration = {}
    },
    async onTemplateChangeCalculateButtonLength (nudge) {
      if (nudge) {
        nudge.dynamic_value_configuration = {}
      } else {
        this.dynamic_value_configuration = {}
      }

      let nudgeTemplateList = []

      if (this.msgTemplateName) {
        nudgeTemplateList.push(this.msgTemplateName)
      }
      this.followupNudges.delays.forEach(nudge => {
        if (nudge.msg_template_name) {
          nudgeTemplateList.push(nudge.msg_template_name)
        }
      })

      const queryString = nudgeTemplateList.map(template => `nudgeList=${encodeURIComponent(template)}`).join('&')

      this.loading = true
      await this.getTurnCountryList()
      const response = await api.buildRequest(`getNudgeButtonCount?${queryString}`, 'GET', { country: this.turnCountry })
      this.loading = false

      const buttonCount = response.data.payload.maxButtonLength
      const currentCount = this.entries.length

      if (buttonCount > currentCount) {
        // Add new buttons
        const newEntries = Array.from({ length: buttonCount - currentCount }, () => ({
          scheduledAppKeyword: null,
          scheduledAppConversation: null,
          scheduledKeywordlessConversation: null,
          isInvalidKeywordConversation: false
        }))
        this.entries = [...this.entries, ...newEntries]
      } else if (buttonCount < currentCount) {
        // Remove excess buttons
        this.entries = this.entries.slice(0, buttonCount)
      }
    },
    toLowerCaseFunc (e) {
      this.stagename = e.target.value.toLowerCase()
    },
    toLowerCaseFuncNextStage (e) {
      this.nextStages = e.target.value.toLowerCase()
    },
    toLowerCaseFuncSematicNext (e) {
      this.semanticObj.next = e.target.value.toLowerCase()
      this.semanticObj.next = this.semanticObj.next.replace(/,/g, '').trim()
    },
    async parseSemanticData () {
      this.semanticData = []
      let optionsArray = []
      if (this.options) {
        optionsArray = this.options.split(/,\s*/)
      }
      let nextArray = []
      if (this.nextStages) {
        nextArray = this.nextStages.split(/,\s*/)
      }
      if (optionsArray && Object.keys(optionsArray).length) {
        for (var opt in optionsArray) {
          const data = {}
          data.option = (optionsArray && optionsArray[opt]) ? optionsArray[opt] : ''
          data.next = (nextArray && nextArray[opt]) ? nextArray[opt] : ''
          data.semantic = (this.semantic && this.semantic[opt]) ? this.semantic[opt] : {}
          data.optionScore = (this.optionScores[optionsArray[opt]] || this.optionScores[optionsArray[opt]] === 0) ? this.optionScores[optionsArray[opt]] : ''
          data.tallyLowerLimit = this.rankingScores[optionsArray[opt]] && (this.rankingScores[optionsArray[opt]]['tally_lower_limit'] || parseInt(this.rankingScores[optionsArray[opt]]['tally_lower_limit']) === 0) ? this.rankingScores[optionsArray[opt]]['tally_lower_limit'] : null
          data.tallyUpperLimit = this.rankingScores[optionsArray[opt]] && (this.rankingScores[optionsArray[opt]]['tally_upper_limit'] || parseInt(this.rankingScores[optionsArray[opt]]['tally_upper_limit']) === 0) ? this.rankingScores[optionsArray[opt]]['tally_upper_limit'] : null
          if (this.optionConfig) {
            const currentOptionConfig = this.optionConfig[opt]
            data.isDynamicOptionsEnable = currentOptionConfig ? currentOptionConfig.dynamic : false
            if (data.isDynamicOptionsEnable) {
              data.optionListSource = currentOptionConfig ? currentOptionConfig.for : ''
              data.dataDestination = currentOptionConfig ? currentOptionConfig.dataDestination ? _.findKey(dataDestinationConfig, currentOptionConfig.dataDestination) || '' : '' : ''
              data.staticOptionTextConfig = {}
              this.availableDataDestination = dynamicInputConfig[data.optionListSource].dataDestination
            } else {
              data.optionListSource = ''
              data.dataDestination = ''
              data.staticOptionTextConfig = currentOptionConfig ? currentOptionConfig.option_text : {}
            }
          } else {
            data.optionListSource = ''
            data.dataDestination = ''
            data.staticOptionTextConfig = {}
            data.isDynamicOptionsEnable = false
          }
          this.semanticData.push(data)
        }
      } else if (nextArray && Object.keys(nextArray).length) {
        for (var optNext in nextArray) {
          const data = {}
          data.option = (optionsArray && optionsArray[optNext]) ? optionsArray[optNext] : ''
          data.next = (nextArray && nextArray[optNext]) ? nextArray[optNext] : ''
          data.semantic = (this.semantic && this.semantic[optNext]) ? this.semantic[optNext] : {}
          data.optionScore = (this.optionScores[optionsArray[opt]] || this.optionScores[optionsArray[opt]] === 0) ? this.optionScores[optionsArray[opt]] : ''
          if (this.optionConfig) {
            const currentOptionConfig = this.optionConfig[optNext]
            data.isDynamicOptionsEnable = currentOptionConfig ? currentOptionConfig.dynamic : false
            if (data.isDynamicOptionsEnable) {
              data.optionListSource = currentOptionConfig ? currentOptionConfig.for : ''
              data.dataDestination = currentOptionConfig ? currentOptionConfig.dataDestination ? _.findKey(dataDestinationConfig, currentOptionConfig.dataDestination) || '' : '' : ''
              data.staticOptionTextConfig = {}
              this.availableDataDestination = dynamicInputConfig[data.optionListSource].dataDestination
            } else {
              data.optionListSource = ''
              data.dataDestination = ''
              data.staticOptionTextConfig = currentOptionConfig ? currentOptionConfig.option_text : {}
            }
          } else {
            data.optionListSource = ''
            data.dataDestination = ''
            data.staticOptionTextConfig = {}
            data.isDynamicOptionsEnable = false
          }
          this.semanticData.push(data)
        }
      }
      this.simplifySematicsData()
      return true
    },
    showNullListInfoPopUp (event) {
      event.preventDefault()
      event.stopPropagation()
      this.showModalNullListInfo = true
    },
    closeNullListInfoPopUp () {
      this.showModalNullListInfo = false
    },
    showRedemptionStageInfoPopUp (event) {
      event.preventDefault()
      event.stopPropagation()
      this.showRedemptionStageInfo = true
    },
    closeRedemptionStageInfoPopUp () {
      this.showRedemptionStageInfo = false
    },
    openSemantic (item, index) {
      this.semanticMessage = ''
      if (Object.keys(this.countryAndLanguages).length === 0) {
        this.getLanguages()
      }
      this.showModalSemantic = true
      if (item) {
        this.isSemanticMessageEdit = true
        this.semanticObj = JSON.parse(JSON.stringify(item)) // to clone
        this.semanticObj.index = index
      } else {
        this.isSemanticMessageEdit = false
        this.semanticObj = {
          isDynamicOptionsEnable: false,
          option: '',
          optionScore: '',
          tallyLowerLimit: null,
          tallyUpperLimit: null,
          next: '',
          semantic: {},
          optionListSource: '',
          staticOptionTextConfig: {},
          dataDestination: ''
        }
      }
      this.selectedCountrySemantic = ''
      this.messageLanguageSemantic = ''
      this.selectedCountryStaticOption = ''
      this.textLanguageStaticOption = ''
    },
    async replaceOptionWarning () {
      const result = await this.$swal({
        type: 'warning',
        text: 'Options are already available do you want to Replace it',
        confirmButtonText: 'Yes',
        showCancelButton: true
      })

      return result
    },
    addAgeRange () {
      this.ageList.push({
        ageLowerLimit: null,
        ageUpperLimit: null
      })
    },
    addKeywordsMapping () {
      this.keywordMappingList.push({
        conversationId: null,
        keywordsList: []
      })
    },
    async generateOptionForKeywordMapping (keywordMappingList) {
      if (keywordMappingList.length === 0) {
        return this.$swal({
          type: 'error',
          text: 'Please select at least one mapping'
        })
      }
      let keywordMappingListLength = keywordMappingList.length
      console.log('kw list', keywordMappingListLength)
      let optionCreate = true
      this.submitted = true
      this.$v.$touch()
      const isValidForm = this.validateKeywordMappingList()
      console.log('ISVALID FORM: ', isValidForm)
      if (!isValidForm) {
        console.log('Invalid form....')
        return
      }
      if (optionCreate === true) {
        if (this.semanticData.length) {
          let modalResult = await this.replaceOptionWarning()
          if (modalResult.value) {
            this.semanticData = []
            if (optionCreate === true) {
              keywordMappingList.forEach((keywordMapping, index) => {
                let mappingString = `keyword_set_${index + 1}`
                if (keywordMapping.mappingUniqueId && keywordMapping.mappingUniqueId.length > 0) {
                  mappingString = keywordMapping.mappingUniqueId
                }
                this.semanticData.push({
                  option: mappingString,
                  next: mappingString,
                  semantic: {},
                  staticOptionTextConfig: {}
                })
              })
              var result = this.semanticData.findIndex(item => item.option === 'default')
              if (result === -1) {
                this.semanticData.push({
                  option: 'default',
                  next: 'default',
                  semantic: {},
                  staticOptionTextConfig: {}
                })
              }
              this.simplifySematicsData()
              this.configurePfSave()
            }
            return
          }
          return
        }

        keywordMappingList.forEach((keywordMapping, index) => {
          let mappingString = `keyword_set_${index + 1}`
          if (keywordMapping.mappingUniqueId && keywordMapping.mappingUniqueId.length > 0) {
            mappingString = keywordMapping.mappingUniqueId
          }
          this.semanticData.push({
            option: mappingString,
            next: mappingString,
            semantic: {},
            staticOptionTextConfig: {}
          })
        })
        result = this.semanticData.findIndex(item => item.option === 'default')
        if (result === -1) {
          this.semanticData.push({
            option: 'default',
            next: 'default',
            semantic: {},
            staticOptionTextConfig: {}
          })
        }
        this.simplifySematicsData()
        this.configurePfSave()
      }
      return
    },
    async generateOptionForAgeRange (ageList) {
      if (ageList.length === 0) {
        return this.$swal({
          type: 'error',
          text: 'Please select at least one age group'
        })
      }
      let ageListLength = ageList.length
      console.log('age range', ageListLength)
      let optionCreate = true
      this.submitted = true
      this.$v.$touch()
      ageList.forEach((agerange) => {
        let lowerLimit = agerange.ageLowerLimit
        let upperLimit = agerange.ageUpperLimit
        if (this.$v.$invalid && (!lowerLimit || !upperLimit || isNaN(lowerLimit) || isNaN(upperLimit) || parseInt(lowerLimit) < 0 || parseInt(upperLimit) > 99 || parseInt(upperLimit) <= parseInt(lowerLimit))) {
          optionCreate = false
          return
        }
      })
      if (optionCreate === true) {
        if (this.semanticData.length) {
          let modalResult = await this.replaceOptionWarning()
          if (modalResult.value) {
            this.semanticData = []
            if (optionCreate === true) {
              ageList.forEach((age, index) => {
                let ageString = `${age.ageLowerLimit}_${age.ageUpperLimit}`
                this.semanticData.push({
                  option: ageString,
                  next: ageString,
                  semantic: {},
                  staticOptionTextConfig: {}
                })
              })
              var result = this.semanticData.findIndex(item => item.option === 'default')
              if (result === -1) {
                this.semanticData.push({
                  option: 'default',
                  next: 'default',
                  semantic: {},
                  staticOptionTextConfig: {}
                })
              }
              this.simplifySematicsData()
              this.configurePfSave()
            }
            return
          }
          return
        }

        ageList.forEach((age, index) => {
          let ageString = `${age.ageLowerLimit}_${age.ageUpperLimit}`
          this.semanticData.push({
            option: ageString,
            next: ageString,
            semantic: {},
            staticOptionTextConfig: {}
          })
        })
        result = this.semanticData.findIndex(item => item.option === 'default')
        if (result === -1) {
          this.semanticData.push({
            option: 'default',
            next: 'default',
            semantic: {},
            staticOptionTextConfig: {}
          })
        }
        this.simplifySematicsData()
        this.configurePfSave()
      }
      return
    },
    async checkAndGenerateOptionForRandomSplitPF (functionInput) {
      this.submitted = true
      this.$v.functionInput.$touch()
      if (this.$v.functionInput.$invalid) {
        return
      }
      let percentageARR = functionInput.split(',')
      percentageARR = percentageARR.filter(Number)
      percentageARR = percentageARR.map(Number)
      let sum = 0
      percentageARR.forEach((percentage) => {
        sum += percentage
      })
      if (sum !== 100) {
        return this.$swal({
          type: 'error',
          text: 'split percentage must be 100'
        })
      }
      if (this.semanticData.length) {
        let result = await this.replaceOptionWarning()

        if (result.value) {
          this.semanticData = []
          percentageARR.forEach((item, index) => {
            this.semanticData.push({
              option: `random_split_${index + 1}`,
              next: `random_split_${index + 1}`,
              semantic: {},
              staticOptionTextConfig: {}
            })
          })
          this.simplifySematicsData()
          this.configurePfSave()
        }
        return
      }
      percentageARR.forEach((item, index) => {
        this.semanticData.push({
          option: `random_split_${index + 1}`,
          next: `random_split_${index + 1}`,
          semantic: {},
          staticOptionTextConfig: {}
        })
      })
      this.simplifySematicsData()
      this.configurePfSave()
    },
    async generateOptionFordDemographicPF (demographicValue) {
      let configureOptions = this.demographicOptions[demographicValue]
      this.submitted = true
      this.$v.$touch()

      if (this.$v.demographicValue.$invalid) {
        return
      }
      if (this.semanticData.length) {
        let result = await this.replaceOptionWarning()
        if (result.value) {
          this.semanticData = []
          configureOptions.values.forEach((value) => {
            this.semanticData.push({
              option: value,
              next: value,
              semantic: {},
              staticOptionTextConfig: {}
            })
          })
          this.functionInput = configureOptions.label
          this.simplifySematicsData()
          this.configurePfSave()
        }
        return
      }

      configureOptions.values.forEach((value) => {
        this.semanticData.push({
          option: value,
          next: value,
          semantic: {},
          staticOptionTextConfig: {}
        })
      })

      this.functionInput = configureOptions.label
      this.simplifySematicsData()
      this.configurePfSave()
    },
    async generateOptionForBookingStatusPF () {
      let configureOptions = bookingStatusOptions
      this.submitted = true
      this.$v.$touch()

      if (this.semanticData.length) {
        let result = await this.replaceOptionWarning()
        if (result.value) {
          this.semanticData = []
          configureOptions.forEach((option) => {
            this.semanticData.push({
              option: option.value,
              next: option.value,
              semantic: {},
              staticOptionTextConfig: {}
            })
          })
          this.simplifySematicsData()
          this.configurePfSave()
        }
        return
      }

      configureOptions.forEach((option) => {
        this.semanticData.push({
          option: option.value,
          next: option.value,
          semantic: {},
          staticOptionTextConfig: {}
        })
      })
      this.simplifySematicsData()
      this.configurePfSave()
    },
    async generateYesNoOptions () {
      let configureOptions = yesNoOptions
      this.submitted = true
      this.$v.$touch()
      if (this.$v.selectedReferralType.$invalid) {
        console.log('this.$v.selectedReferralType.$invalid: ', this.$v.selectedReferralType.$invalid)
        return
      }

      if (this.semanticData.length) {
        let result = await this.replaceOptionWarning()
        if (result.value) {
          this.semanticData = []
          configureOptions.forEach((option) => {
            this.semanticData.push({
              option: option.value,
              next: option.value,
              semantic: {},
              staticOptionTextConfig: {}
            })
          })
          this.simplifySematicsData()
          this.configurePfSave()
        }
        return
      }

      configureOptions.forEach((option) => {
        this.semanticData.push({
          option: option.value,
          next: option.value,
          semantic: {},
          staticOptionTextConfig: {}
        })
      })
      this.simplifySematicsData()
      this.configurePfSave()
    },
    generateOptionForDigitalVoucherValidation () {
      console.log('inside generateOptionForDigitalVoucherValidation')
      let configureOptions = digitalVoucherValidationOptions
      if (this.semanticData.length) {
        this.$swal({
          type: 'warning',
          text: 'Options are already available do you want to Replace it',
          confirmButtonText: 'Yes',
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.semanticData = []
            configureOptions.forEach((option) => {
              this.semanticData.push({
                option: option,
                next: option,
                semantic: {},
                staticOptionTextConfig: {}
              })
            })
            this.simplifySematicsData()
            this.configurePfSave()
          }
        })
        return
      } else {
        configureOptions.forEach((option) => {
          this.semanticData.push({
            option: option,
            next: option,
            semantic: {},
            staticOptionTextConfig: {}
          })
        })
        this.simplifySematicsData()
        this.configurePfSave()
      }
    },
    async generateInsurancePlanOptions () {
      let configureOptions = insurancePlanOptions
      this.submitted = true
      this.$v.$touch()
      // if (this.$v.selectedReferralType.$invalid) {
      //   console.log('this.$v.selectedReferralType.$invalid: ', this.$v.selectedReferralType.$invalid)
      //   return
      // }

      console.log('this.semanticData inside generateInsurancePlanOptions: ', this.semanticData)

      if (this.semanticData.length) {
        let result = await this.replaceOptionWarning()
        if (result.value) {
          this.semanticData = []
          configureOptions.forEach((option) => {
            this.semanticData.push({
              option: option.value,
              next: option.value,
              semantic: {},
              staticOptionTextConfig: {}
            })
          })
          this.simplifySematicsData()
          this.configurePfSave()
        }
        return
      }

      configureOptions.forEach((option) => {
        this.semanticData.push({
          option: option.value,
          next: option.value,
          semantic: {},
          staticOptionTextConfig: {}
        })
      })
      this.simplifySematicsData()
      this.configurePfSave()
    },
    async checkAndGenerateOptionForAnswerLookUp (generatedOption) {
      this.submitted = true
      this.$v.selectedconversation.$touch()
      this.$v.stageSelected.$touch()
      if (this.$v.selectedconversation.$invalid || this.$v.stageSelected.$invalid) {
        return
      }
      if (generatedOption) {
        if (this.semanticData.length) {
          let result = await this.replaceOptionWarning()
          if (result.value) {
            this.semanticData = []
            generatedOption.forEach((option) => {
              this.semanticData.push({
                option: option,
                next: option,
                semantic: {},
                staticOptionTextConfig: {}
              })
            })
            var defaultResult = this.semanticData.findIndex(item => item.option === 'default')
            if (defaultResult === -1) {
              this.semanticData.push({
                option: 'default',
                next: 'default',
                semantic: {},
                staticOptionTextConfig: {}
              })
            }
            if (this.conversationOptions && this.conversationOptions[this.selectedconversation] && this.conversationOptions[this.selectedconversation]['label'] && this.stageOptions && this.stageOptions[this.stageSelected] && this.stageOptions[this.stageSelected]['label']) {
              this.functionInput = `${this.conversationOptions[this.selectedconversation]['label']},${this.stageOptions[this.stageSelected]['label']}`
            }
            this.simplifySematicsData()
            this.configurePfSave()
          }
          return
        }
        generatedOption.forEach((option) => {
          this.semanticData.push({
            option: option,
            next: option,
            semantic: {},
            staticOptionTextConfig: {}
          })
        })
        if (defaultResult === -1) {
          this.semanticData.push({
            option: 'default',
            next: 'default',
            semantic: {},
            staticOptionTextConfig: {}
          })
        }
        if (this.conversationOptions && this.conversationOptions[this.selectedconversation] && this.conversationOptions[this.selectedconversation]['label'] && this.stageOptions && this.stageOptions[this.stageSelected] && this.stageOptions[this.stageSelected]['label']) {
          this.functionInput = `${this.conversationOptions[this.selectedconversation]['label']},${this.stageOptions[this.stageSelected]['label']}`
        }
        console.log('functionInputStage2', this.functionInput)
        this.simplifySematicsData()
        this.configurePfSave()
      } else {
        if (this.semanticData.length) {
          let result = await this.replaceOptionWarning()
          if (result.value) {
            this.semanticData = []
            this.showModalPf = false
          }
          return
        }
        this.showModalPf = false
      }
    },
    async checkAndGenerateOptionForScoreRank (generateScoredResponseOption) {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.scoredResponseSelected.$invalid) {
        return
      }
      if (generateScoredResponseOption) {
        if (this.semanticData.length) {
          let result = await this.replaceOptionWarning()
          if (result.value) {
            this.semanticData = []
            generateScoredResponseOption.forEach((option) => {
              this.semanticData.push({
                option: option,
                next: option,
                semantic: {},
                staticOptionTextConfig: {}
              })
            })
            var defaultResult = this.semanticData.findIndex(item => item.option === 'default')
            if (defaultResult === -1) {
              this.semanticData.push({
                option: 'default',
                next: 'default',
                semantic: {},
                staticOptionTextConfig: {}
              })
            }
            if (this.scoredResponseConversationOptions && this.scoredResponseConversationOptions[this.scoredResponseSelected] && this.scoredResponseConversationOptions[this.scoredResponseSelected]['label']) {
              this.functionInput = `${this.scoredResponseConversationOptions[this.scoredResponseSelected]['label']}`
            }
            this.simplifySematicsData()
            this.configurePfSave()
          }
          return
        }
        generateScoredResponseOption.forEach((option) => {
          this.semanticData.push({
            option: option,
            next: option,
            semantic: {},
            staticOptionTextConfig: {}
          })
        })
        if (defaultResult === -1) {
          this.semanticData.push({
            option: 'default',
            next: 'default',
            semantic: {},
            staticOptionTextConfig: {}
          })
        }
        if (this.scoredResponseConversationOptions && this.scoredResponseConversationOptions[this.scoredResponseSelected] && this.scoredResponseConversationOptions[this.scoredResponseSelected]['label']) {
          this.functionInput = `${this.scoredResponseConversationOptions[this.scoredResponseSelected]['label']}`
        }
        this.simplifySematicsData()
        this.configurePfSave()
      } else {
        if (this.semanticData.length) {
          let result = await this.replaceOptionWarning()
          if (result.value) {
            this.semanticData = []
            this.showModalPf = false
          }
          return
        }
        this.showModalPf = false
      }
    },
    async checkAndGenerateOptionForLocationPF (input, locationType) {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.locationType.$invalid || this.$v.functionInput.$invalid) {
        return
      }

      if (this.semanticData.length) {
        let result = await this.replaceOptionWarning()
        if (result.value) {
          this.semanticData = []
          input.split(',').forEach((value) => {
            if (value.trim()) {
              this.semanticData.push({
                option: value.trim(),
                next: value.trim(),
                semantic: {},
                staticOptionTextConfig: {}
              })
            }
          })
          let defaultResult = this.semanticData.findIndex(item => item.option === 'default')
          if (defaultResult === -1) {
            this.semanticData.push({
              option: 'default',
              next: 'default',
              semantic: {},
              staticOptionTextConfig: {}
            })
          }
          this.functionInput = `${locationType}|${input}`
          this.simplifySematicsData()
          this.configurePfSave()
        }
        return
      }

      input.split(',').forEach((value) => {
        if (value.trim()) {
          this.semanticData.push({
            option: value.trim(),
            next: value.trim(),
            semantic: {},
            staticOptionTextConfig: {}
          })
        }
      })

      this.semanticData.push({
        option: 'default',
        next: 'default',
        semantic: {},
        staticOptionTextConfig: {}
      })

      this.functionInput = `${locationType}|${input}`
      this.simplifySematicsData()
      this.configurePfSave()
    },
    async checkUserIsInANCOnboarding () {
      if (this.semanticData.length) {
        let result = await this.replaceOptionWarning()
        if (result.value) {
          this.semanticData = []
        } else {
          return
        }
      }
      this.semanticData.push({
        option: 'anc_yes',
        next: 'anc_yes',
        semantic: {},
        staticOptionTextConfig: {}
      }, {
        option: 'anc_no',
        next: 'anc_no',
        semantic: {},
        staticOptionTextConfig: {}
      })
      this.functionInput = ''
      this.simplifySematicsData()
      this.configurePfSave()
    },
    generateOption (functionName) {
      switch (functionName) {
        case 'navigateToNextStageBasedOnRandomSplit':
          return this.checkAndGenerateOptionForRandomSplitPF(this.functionInput)
        case 'navigateToNextStageBasedOnAgeRange':
          return this.generateOptionForAgeRange(this.ageList)
        case 'navigateBasedOnKeyword':
          return this.generateOptionForKeywordMapping(this.keywordMappingList)
        case 'fetchValueBasedOnSelectedDemographic':
          return this.generateOptionFordDemographicPF(this.demographicValue)
        case 'navigateToNextStageBasedOnBookingStatus':
          return this.generateOptionForBookingStatusPF()
        case 'navigateToNextStageFromAnswer':
          return this.checkAndGenerateOptionForAnswerLookUp(this.optionGenerate)
        case 'navigateToNextStageFromScoreRank':
          return this.checkAndGenerateOptionForScoreRank(this.optionGenerateScoredResponse)
        case 'navigateToNextStageBasedOnUsersLocation':
          return this.checkAndGenerateOptionForLocationPF(this.functionInput, this.locationType)
        case 'navigateToNextStageBasedOnUsersLocationSubstring':
          return this.checkAndGenerateOptionForLocationPF(this.functionInput, this.locationType)
        case 'checkUserIsInANCOnboarding':
          return this.checkUserIsInANCOnboarding()
        case 'checkUserHaveSpecificReferral':
        case 'checkIfResourceExistNearUserLocation':
        case 'navigateToNextStageBasedExistanceOfRecommendation':
          return this.generateYesNoOptions()
        case 'navigateToNextStageBasedOnInsurancePlan':
          return this.generateInsurancePlanOptions()
        case 'validateDigitalVoucherCode':
          return this.generateOptionForDigitalVoucherValidation()
        default:
          break
      }
      this.getProcessingFunctionAlias(functionName)
    },
    updateValue (node) {
      if (node || node === 0) {
        this.optionDisplayArr = this.demographicOptions[node].values
      } else {
        this.optionDisplayArr = []
      }
    },
    removeGroup (index) {
      this.ageList.splice(index, 1)
    },
    configurePf (e) {
      e.preventDefault()
      this.showModalPf = true
      this.keywordMappingList = [{
        conversationId: null,
        keywordsList: [],
        mappingUniqueId: ''
      }]
      if (!(this.stageDetails && this.stageDetails.processingFunctionConfig && this.stageDetails.processingFunctionConfig.functionName)) {
        this.isInputRequired = false
      } else {
        if (this.stageDetails.processingFunctionConfig.functionName === 'checkUserHaveSpecificReferral') {
          specificReferralTypes.forEach((referral) => {
            console.log('referral.label: ', referral)
            console.log('this.stageDetails.processingFunctionConfig.inputConfig: ', this.stageDetails.processingFunctionConfig.inputConfig)
            if (referral.id.trim().toLowerCase() === this.stageDetails.processingFunctionConfig.inputConfig.trim().toLowerCase()) {
              this.selectedReferralType = referral.id
              return
            }
          })
        }
        if (this.stageDetails.processingFunctionConfig.functionName === 'checkIfResourceExistNearUserLocation') {
          const inputConfig = this.stageDetails.processingFunctionConfig.inputConfig.split('|')
          this.selectedLocationType = inputConfig[0] || null
          this.selectedKmDistance = inputConfig[1] || null
          this.selectedOfferings = (inputConfig[2] && inputConfig[2].split(',')) || []
          this.allSelectedServices = this.servicesList.every(service => this.selectedOfferings.includes(service.id))
          this.allSelectedProducts = this.productList.every(service => this.selectedOfferings.includes(service.id))
        }
        if (this.stageDetails.processingFunctionConfig.functionName === 'fetchValueBasedOnSelectedDemographic') {
          demographicOptions.forEach((option) => {
            if (option.label.trim().toLowerCase() === this.stageDetails.processingFunctionConfig.inputConfig.trim().toLowerCase()) {
              this.demographicValue = option.id
              this.optionDisplayArr = option.values
              return
            }
          })
        } else if (this.stageDetails.processingFunctionConfig.functionName === 'navigateToNextStageFromAnswer') {
          let isConversationPresent = false
          let isStagePresent = false
          this.newFunctionInput = this.stageDetails.processingFunctionConfig.inputConfig.split(',')
          if (this.conversationOptions !== []) {
            this.conversationOptions.forEach((option) => {
              if (option && option.label) {
                if (option.label.trim().toLowerCase() === this.newFunctionInput[0].trim().toLowerCase()) {
                  this.selectedconversation = option.id
                  isConversationPresent = true
                  this.getStages(option.id)
                  this.stageOptions.forEach((option) => {
                    if (option.label.trim().toLowerCase() === this.newFunctionInput[1].trim().toLowerCase()) {
                      this.stageSelected = option.id
                      isStagePresent = true
                      this.getOptions(option.id)
                    }
                  })
                  return
                }
              }
            })
            if (!isConversationPresent) {
              this.selectedconversation = 'GENERIC_SMS_APP###' + this.newFunctionInput[0].trim()
            }
            if (!isStagePresent) {
              this.stageSelected = 'GENERIC_SMS_APP###' + this.newFunctionInput[1].trim()
            }
          }
        } else if (this.stageDetails.processingFunctionConfig.functionName === 'navigateToNextStageFromScoreRank') {
          let isConversationPresent = false
          this.scoredResponseConversationOptions.forEach((option) => {
            if (option && option.label) {
              if (option.label.trim().toLowerCase() === this.stageDetails.processingFunctionConfig.inputConfig.trim().toLowerCase()) {
                this.scoredResponseSelected = option.id
                this.getOptionsForScoredResponse(option.id)
                isConversationPresent = true
                return
              }
            }
          })
          if (!isConversationPresent) {
            this.scoredResponseSelected = 'GENERIC_SMS_APP###' + this.stageDetails.processingFunctionConfig.inputConfig.trim()
          }
        } else if (this.stageDetails.processingFunctionConfig.functionName === 'navigateToNextStageBasedOnAgeRange') {
          this.submitted = false
          let ages = this.stageDetails.options
          if (!this.ageList[0].ageLowerLimit && !this.ageList[0].ageUpperLimit && ages) {
            this.ageList = []
            ages.forEach((age) => {
              let [lowerAge, upperAge] = age.split('_')
              if (lowerAge && upperAge) {
                this.ageList.push({
                  ageLowerLimit: lowerAge,
                  ageUpperLimit: upperAge
                })
              }
            })
          }
        } else if (this.stageDetails.processingFunctionConfig.functionName === 'navigateBasedOnKeyword') {
          this.submitted = false
          if (this.stageDetails.processingFunctionConfig.inputConfig && Object.keys(this.stageDetails.processingFunctionConfig.inputConfig).length) {
            this.keywordMappingList = []
            const inputConfig = this.stageDetails.processingFunctionConfig.inputConfig
            Object.keys(inputConfig).forEach((config, index) => {
              console.log(inputConfig)
              const keywordMapping = {
                conversationId: inputConfig[config].conversationId,
                keywordsList: inputConfig[config].keywords,
                mappingUniqueId: config
              }
              this.keywordMappingList.push(keywordMapping)
            })
          }
        } else if (this.stageDetails.processingFunctionConfig.functionName === 'setImplicitReferrals') {
          this.pfStoredReferralsList = this.stageDetails.processingFunctionConfig.inputConfig
        } else if (this.stageDetails.processingFunctionConfig.functionName === 'navigateToNextStageBasedOnUsersLocation' || this.stageDetails.processingFunctionConfig.functionName === 'navigateToNextStageBasedOnUsersLocationSubstring') {
          let pfInput = this.stageDetails.processingFunctionConfig.inputConfig.split('|')
          this.locationType = pfInput[0]
          this.functionInput = pfInput[1]
        }
      }
      let category
      this.functions.forEach((fn) => {
        if (fn.function_name === this.functionName) {
          category = fn.category
        }
      })
      this.selectedCategory = this.functions.filter((func) => { return func.category === category })
      this.categories.forEach((fn) => {
        if (fn.label === category) {
          this.currentStoredValue = fn.id
        }
      })
    },
    closeSemantic () {
      this.showModalSemantic = false
      this.submittedSemantic = false
    },
    closeConfigurePf (e) {
      e.preventDefault()
      if (this.stageDetails && this.stageDetails.processingFunctionConfig && this.stageDetails.processingFunctionConfig.functionName) {
        this.functionName = this.stageDetails.processingFunctionConfig.functionName
        if (this.functionName === 'setImplicitReferrals') {
          this.referralValues = []
          this.pfStoredReferralsList.forEach((referral) => {
            this.referralValues.push(referral.id)
          })
        } else {
          this.functionInput = this.stageDetails.processingFunctionConfig.inputConfig
        }
        this.showModalPf = false
      } else {
        this.currentStoredValue = null
        this.functionName = ''
        this.functionDescription = ''
        this.functionInput = ''
        this.isInputRequired = false
        this.showModalPf = false
        this.demographicValue = null
        this.optionDisplayArr = []
        this.referralValues = []
      }
    },
    deletePf (e) {
      e.preventDefault()
      this.ageList = [{
        ageLowerLimit: null,
        ageUpperLimit: null
      }]
      this.functionName = ''
      this.functionDescription = ''
      this.functionInput = ''
      this.isInputRequired = false
      this.functionAlias = ''
      this.optionDisplayArr = []
      this.currentStoredValue = null
      this.referralValues = []
      this.selectedReferralType = null
      this.pfStoredReferralsList = []
      this.selectedLocationType = null
      this.selectedKmDistance = null
      this.selectedOfferings = []
      if (this.stageDetails && this.stageDetails.processingFunctionConfig && this.stageDetails.processingFunctionConfig.functionName) {
        this.stageDetails.processingFunctionConfig.functionName = ''
      }
    },
    refreshApps () {
      this.$emit('getAllApps')
    },
    getConversationsList (value) {
      console.log('Inside getconvlist: ', value)
      this.conversationOptions = []
      this.scoredResponseConversation = []
      this.scoredResponseConversationOptions = []
      if (Array.isArray(value) && value.length > 0) {
        value.map((item, index) => {
          this.conversationOptions.push({ id: index, label: item && item.data && item.data.name, conversation_id: item.appId })
          if (item && item.data && item.data.type === 'scoredresponse') {
            this.scoredResponseConversation.push(item)
          }
        })
      }
      if (Array.isArray(this.scoredResponseConversation) && this.scoredResponseConversation.length > 0) {
        this.scoredResponseConversation.map((item, index) => {
          this.scoredResponseConversationOptions.push({ id: index, label: item && item.data && item.data.name })
        })
      }
    },
    getStages (node) {
      this.stageSelected = null
      this.stageOptions = []
      this.selectedStages = []
      if (this.filteredApps[node] && this.filteredApps[node].data && this.filteredApps[node].data.stages) {
        let stages = this.filteredApps[node].data.stages
        Object.keys(stages).forEach((value, index) => {
          this.stageOptions.push({ id: index, label: value })
          this.selectedStages.push(stages[value])
        })
      }
    },
    getOptions (node) {
      let options
      if (this.selectedStages[node] && this.selectedStages[node]['options']) {
        options = this.selectedStages[node]['options']
      }
      if (options) {
        var defaultResult = options.findIndex(item => item === 'default')
        if (defaultResult === -1) {
          options.push('default')
        }
        this.optionDisplayArr = options
      } else {
        this.optionDisplayArr = []
      }
      this.optionGenerate = options
    },
    getOptionsForScoredResponse (node) {
      let selectedConversation = this.scoredResponseConversation[node]
      console.log('selectedConversation', selectedConversation)
      if (selectedConversation && selectedConversation.data && selectedConversation.data.stages) {
        let stages = selectedConversation.data.stages
        Object.keys(stages).forEach((value, index) => {
          if (stages[value].stageType === 'scoreranking') {
            this.optionGenerateScoredResponse = stages[value].options
            if (this.optionGenerateScoredResponse) {
              var defaultResult = this.optionGenerateScoredResponse.findIndex(item => item === 'default')
              if (defaultResult === -1) {
                this.optionGenerateScoredResponse.push('default')
              }
              this.optionDisplayArr = this.optionGenerateScoredResponse
            } else {
              this.optionDisplayArr = []
            }
            return
          }
        })
      } else {
        this.optionDisplayArr = []
      }
    },
    async findReferralsNameFromId (Id) {
      return api.buildRequest('findReferralsNameFromId', 'POST', {'id': Id})
      .then(response => {
        let resources = response.data.payload
        let options = []
        resources.forEach(resource => {
          options.push({id: resource.id, name: resource.full_name})
        })
        return options
      })
    },
    async configurePfSave () {
      console.log('!!!!!!!!!!!!!! this.functionname: ', this.functionName)
      this.submitted = true
      this.$v.functionInput.$touch()
      this.$v.referralValues.$touch()
      this.$v.selectedReferralType.$touch()
      this.$v.selectedLocationType.$touch()
      this.$v.selectedKmDistance.$touch()
      this.$v.selectedOfferings.$touch()
      if (this.isInputRequired && this.$v.functionInput.$invalid) {
        return
      }
      if (this.$v.referralValues.$invalid) {
        return
      }
      if (this.$v.selectedReferralType.$invalid) {
        return
      }
      if (this.$v.selectedLocationType.$invalid || this.$v.selectedKmDistance.$invalid || this.$v.selectedOfferings.$invalid) {
        return
      }
      if (this.functionName === 'setImplicitReferrals') {
        let resp = await this.findReferralsNameFromId(this.referralValues)
        this.pfStoredReferralsList = resp
        this.functionInput = resp
      }
      if (this.functionName === 'checkUserHaveSpecificReferral') {
        this.functionInput = this.selectedReferralType
      }
      if (this.functionName === 'checkIfResourceExistNearUserLocation') {
        this.functionInput = `${this.selectedLocationType}|${this.selectedKmDistance}|${this.selectedOfferings.join(',')}`
      }
      if (this.functionName === 'navigateBasedOnKeyword') {
        const newFunctionInput = {}
        this.keywordMappingList.forEach((item) => {
          console.log('##ITEM:: ', item)
          newFunctionInput[item.mappingUniqueId] = {
            conversationId: item.conversationId,
            keywords: item.keywordsList
          }
        })
        this.functionInput = newFunctionInput
      }

      this.stageDetails.processingFunctionConfig = { functionName: this.functionName, inputConfig: this.functionInput }
      this.showModalPf = false
      this.getProcessingFunctionAlias(this.functionName)
    },
    filterPf (node, instanceId) {
      this.selectedCategory = this.functions.filter((func) => { return func.category === node.label })
      this.functionName = ''
      this.optionDisplayArr = []
      this.isInputRequired = false
    },
    deleteSemantic (item, index) {
      this.semanticData.splice(index, 1)
      this.simplifySematicsData()
    },
    getLanguagesInCountry () {
      if (!this.selectedCountrySemantic) {
        this.languages = []
      } else {
        this.languages = this.countryAndLanguages[this.selectedCountrySemantic]
      }
    },
    listMoved () {
      this.optionConfig = []
      this.simplifySematicsData()
    },
    simplifySematicsData () {
      if (this.semanticData) {
        let optionsData = this.semanticData.map(a => a.option)
        this.options = optionsData ? optionsData.join(', ') : ''
        this.optionScores = {}
        this.semanticData.forEach((option) => {
          if (option.optionScore || option.optionScore === 0) {
            this.optionScores[option.option] = Number(option.optionScore)
          }
        })
        this.rankingScores = {}
        this.semanticData.forEach(option => {
          let score = {}
          score = {
            'tally_lower_limit': (option.tallyLowerLimit || (option.tallyLowerLimit === 0)) ? Number(option.tallyLowerLimit) : null,
            'tally_upper_limit': (option.tallyUpperLimit || (option.tallyUpperLimit === 0)) ? Number(option.tallyUpperLimit) : null
          }
          this.rankingScores[option.option] = score
        })
        let nextData = this.semanticData.map(a => a.next)
        this.nextStages = Array.isArray(nextData) ? nextData.join(', ') : nextData
        this.semantic = this.semanticData.map(a => a.semantic)
        this.optionConfig = []
        this.semanticData.map(d => {
          if (this.isDynamicInputType()) {
            if (d.isDynamicOptionsEnable) {
              const { displayAttribute, answerType, answerKey, displayAttributeShortName, displayAttributeFullName } = dynamicInputConfig[d.optionListSource]
              this.optionConfig.push({
                dynamic: true,
                for: d.optionListSource,
                display_attribute: displayAttribute,
                display_attribute_shortName: displayAttributeShortName,
                display_attribute_fullName: displayAttributeFullName,
                answer_key: answerKey,
                answer_type: answerType,
                dataDestination: dataDestinationConfig[d.dataDestination]
              })
            } else {
              if (d.option === 'null_list') {
                this.optionConfig.push({
                  dynamic: false,
                  isNullList: true,
                  option_text: d.staticOptionTextConfig
                })
              } else {
                this.optionConfig.push({
                  dynamic: false,
                  option_text: d.staticOptionTextConfig
                })
              }
            }
          }
        })
      }
    },
    addSemanticMessage () {
      this.semanticMessage = this.semanticMessage.trim()
      if (!this.semanticMessage) {
        return false
      }
      if (!this.selectedCountrySemantic || !this.selectedCountrySemantic.trim()) {
        return false
      }
      if (!this.messageLanguageSemantic || !this.messageLanguageSemantic.trim()) {
        return false
      }
      if (this.semanticObj.semantic && !this.semanticObj.semantic[this.selectedCountrySemantic]) {
        this.semanticObj.semantic[this.selectedCountrySemantic] = {}
        this.semanticObj.semantic[this.selectedCountrySemantic][this.messageLanguageSemantic] = this.semanticMessage
      } else {
        this.semanticObj.semantic[this.selectedCountrySemantic][this.messageLanguageSemantic] = this.semanticMessage
      }
      this.semanticMessage = ''
    },
    semanticSave () {
      this.submittedSemantic = true
      this.$v.semanticObj.$touch()
      if (this.stagetype === stageTypes.scoredResponse && this.$v.semanticObj.optionScore.$invalid) {
        return
      }
      if (this.stagetype === stageTypes.scoreRanking && (this.$v.semanticObj.tallyUpperLimit.$invalid || this.$v.semanticObj.tallyLowerLimit.$invalid)) {
        return
      }
      if (this.stagetype === stageTypes.scoreRanking && this.semanticObj.tallyUpperLimit && this.semanticObj.tallyLowerLimit && (Number(this.semanticObj.tallyUpperLimit) < Number(this.semanticObj.tallyLowerLimit))) {
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: 'Upper limit should be greater than lower limit'
        })
        return
      }
      this.submittedSemantic = false
      this.semanticObj.option = this.semanticObj.option.trim()
      this.semanticObj.next = this.semanticObj.next.trim()
      if (!this.semanticObj.option && !this.semanticObj.next) {
        return false
      } else if (this.semanticObj.isDynamicOptionsEnable && !this.semanticObj.optionListSource) {
        return false
      } else if (this.inputType === 'DynamicNumber' && !this.semanticObj.isDynamicOptionsEnable && _.isEmpty(this.semanticObj.staticOptionTextConfig) && this.semanticObj.option !== 'null_list') {
        return false
      }
      if (this.isSemanticMessageEdit) {
        this.semanticData[this.semanticObj.index] = this.semanticObj
      } else {
        this.semanticData.push(this.semanticObj)
      }
      this.isSemanticMessageEdit = false
      this.semanticMessage = ''
      this.showModalSemantic = false
      this.selectedCountrySemantic = ''
      this.messageLanguageSemantic = ''
      this.simplifySematicsData()
    },
    editSemanticMessage (country, language, message) {
      this.selectedCountrySemantic = country
      this.messageLanguageSemantic = language
      this.semanticMessage = message
    },
    deleteSemanticMessage (country, language) {
      const deleteObj = JSON.parse(JSON.stringify(this.semanticObj))
      delete deleteObj.semantic[country][language]
      if (Object.keys(deleteObj.semantic[country]).length === 0) {
        delete deleteObj.semantic[country]
      }
      this.semanticObj = deleteObj
    },
    isDynamicInputType () {
      return this.inputType === 'DynamicNumber'
    },
    addStaticOptionDisplayText () {
      this.staticOptionDisplayText = this.staticOptionDisplayText.trim()
      if (!this.staticOptionDisplayText) {
        return false
      }
      if (!this.selectedCountryStaticOption || !this.selectedCountryStaticOption.trim()) {
        return false
      }
      if (!this.textLanguageStaticOption || !this.textLanguageStaticOption.trim()) {
        return false
      }
      if (this.semanticObj.staticOptionTextConfig && !this.semanticObj.staticOptionTextConfig[this.selectedCountryStaticOption]) {
        this.semanticObj.staticOptionTextConfig[this.selectedCountryStaticOption] = {}
        this.semanticObj.staticOptionTextConfig[this.selectedCountryStaticOption][this.textLanguageStaticOption] = this.staticOptionDisplayText
      } else {
        this.semanticObj.staticOptionTextConfig[this.selectedCountryStaticOption][this.textLanguageStaticOption] = this.staticOptionDisplayText
      }
      this.staticOptionDisplayText = ''
    },
    editStaticOptionDisplayText (country, language, message) {
      this.selectedCountryStaticOption = country
      this.textLanguageStaticOption = language
      this.staticOptionDisplayText = message
    },
    deleteStaticOptionDisplayText (country, language) {
      const deleteObj = JSON.parse(JSON.stringify(this.semanticObj.staticOptionTextConfig))
      delete deleteObj[country][language]
      if (Object.keys(deleteObj[country]).length === 0) {
        delete deleteObj[country]
      }
      this.semanticObj.staticOptionTextConfig = deleteObj
    },
    getLanguagesForStaticOption () {
      if (!this.selectedCountryStaticOption) {
        this.languagesForStaticOption = []
      } else {
        this.languagesForStaticOption = this.countryAndLanguages[this.selectedCountryStaticOption]
      }
    },
    handleOptionListSourceChange () {
      const {optionListSource} = this.semanticObj

      if (optionListSource === 'offerings') {
        this.semanticObj.dataDestination = ''
      }
      if (optionListSource) {
        this.availableDataDestination = dynamicInputConfig[optionListSource].dataDestination
      } else {
        this.availableDataDestination = []
        this.semanticObj.dataDestination = ''
      }
    },
    handleMediaTypeChange () {
      if (this.mediatype !== 'text') {
        this.inputType = ''
      }
    },
    setRecommendations (methods) {
      for (var opt of methods) {
        if (this.allMethods[opt]) {
          this.allRecommendationMethods[opt] = this.allMethods[opt]
        }
      }
    },
    timeout (time) {
      return new Promise(resolve => setTimeout(resolve, time))
    },
    async parseStageDetails (value) {
      if (value.stageName) {
        this.isRedemptionStage = value.isRedemptionStage
        this.ageList = [{
          ageLowerLimit: null,
          ageUpperLimit: null
        }]
        this.currentStoredValue = null
        this.isDisabledSubsequentApp = true
        if (value.subsequentApp) {
          this.isDisabledSubsequentApp = false
        }
        this.functionName = ''
        this.functionDescription = ''
        this.processingFunctionConfig = value.processingFunctionConfig
        this.stagename = value.stageName
        this.stagetype = value.stageType ? value.stageType : stageTypes.traditional

        // Set timeout to clear everything on stagetype change
        await this.timeout(10)

        this.mediatype = value.mediaType ? value.mediaType : 'text'
        this.uploadedMedia = value.media
        this.options = value.options ? value.options.join(', ') : ''
        this.nextStages = Array.isArray(value.next) ? value.next.join(', ') : value.next
        this.inputType = value.validations ? value.validations.type : ''
        this.whatsappFlowId = value.whatsappFlowId || ''
        this.failed = value.failed
        this.allMessages = value.text ? [...value.text] : []
        this.methods = {...value.methods} || {}
        this.optionScores = value.optionScores || {}
        this.rankingScores = value.rankingScores || {}
        this.nextApp = value.nextApp || null
        this.subsequentApp = value.subsequentApp || null
        this.referralType = value.referralType || null
        this.additionalReferralConfig = {
          showPhysicalResouceAsPerPubliCPrivateSelection: false,
          ...value.additionalReferralConfig
        }
        this.editedStage = value.stageName
        this.notification = value.notification
        this.semantic = value.semantic ? [...value.semantic] : []
        this.embeddedApp = value.conversation
        this.tags = value.tags ? [...value.tags] : []
        if (value.recommendation && value.recommendation.length) {
          this.toggleSwitchRecommendation = true
          this.recommendation = value.recommendation
        } else {
          this.toggleSwitchRecommendation = false
          this.recommendation = []
        }
        if (value.topic && value.frequency) {
          this.frequency = value.frequency
          this.topic = value.topic.title
        } else {
          this.topic = null
        }
        if (value.processingFunctionConfig && value.processingFunctionConfig.functionName) {
          this.toggleConditionalBranching = true
          this.showConditionalBranching = true
          this.functionName = value.processingFunctionConfig.functionName
          this.getDescription()
          this.functionInput = value.processingFunctionConfig && value.processingFunctionConfig.inputConfig || ''
          this.getProcessingFunctionAlias(this.functionName)
        } else {
          this.toggleConditionalBranching = false
          this.showConditionalBranching = false
          this.functionName = ''
          this.functionInput = ''
          this.functionDescription = ''
          this.functionAlias = ''
          this.optionDisplayArr = []
        }

        if (value.delay || value.sendTime || value.scheduledAppKeyword || value.msgTemplateName) {
          this.toggleSwitchDelay = true
          this.showDelayTactics = true
          this.entries = []
          // Separating keyword and keywordless conversation
          if (value.scheduledAppKeyword) {
            if (Array.isArray(value.scheduledAppKeyword)) {
              value.scheduledAppKeyword.forEach((keyword, index) => {
                console.log('inside loop: ', keyword)
                this.entries.push({
                  scheduledAppKeyword: keyword.split('conversationkeyword:')[1] ? null : keyword,
                  scheduledAppConversation: '',
                  scheduledKeywordlessConversation: keyword.split('conversationkeyword:')[1] ? keyword.split('conversationkeyword:')[1] : null,
                  isInvalidKeywordConversation: false
                })
              })
            } else if (typeof value.scheduledAppKeyword === 'string') {
              this.entries = [{
                scheduledAppKeyword: value.scheduledAppKeyword,
                scheduledAppConversation: '',
                scheduledKeywordlessConversation: value.scheduledAppKeyword.split('conversationkeyword:')[1],
                isInvalidKeywordConversation: false
              }]
              if (value.scheduledAppKeyword.split('conversationkeyword:GENERIC_SMS_APP###').length > 1) {
                this.entries[0].scheduledKeywordlessConversation = value.scheduledAppKeyword.split('conversationkeyword:')[1]
              } else {

              }
              this.entries = [{
                scheduledAppKeyword: null,
                scheduledAppConversation: '',
                scheduledKeywordlessConversation: null,
                isInvalidKeywordConversation: false
              }]
              if (value.scheduledAppKeyword.split('conversationkeyword:GENERIC_SMS_APP###').length > 1) {
                this.entries[0].scheduledKeywordlessConversation = value.scheduledAppKeyword.split('conversationkeyword:')[1]
              } else {
                const scheduledKeyword = this.allKeywords.find(item => {
                  return item.keyword === value.scheduledAppKeyword
                })
                this.entries[0].scheduledAppKeyword = scheduledKeyword ? scheduledKeyword.id : null
              }
            } else {
              // console.log("scheduledAppKeyword is neither an array nor a string");
            }
          }

          console.log('this.entries: ', this.entries)
          this.msgTemplateName = value.msgTemplateName || ''
          this.delay = {...value.delay} || {
            quantity: '',
            units: 'days'
          }
          this.dynamic_value_configuration = value.dynamic_value_configuration || {}
          this.sendTime = value.sendTime || {
            hours: '',
            minutes: ''
          }
          if (value.followupNudges) this.followupNudges = value.followupNudges
          else this.followupNudges = { context: null, delays: [] }
        } else {
          this.toggleSwitchDelay = false
          this.showDelayTactics = false
          this.scheduledAppKeyword = null
          this.scheduledKeywordlessConversation = null
          this.scheduledAppConversation = null
          this.msgTemplateName = ''
          this.entries = []
          this.delay = {
            quantity: '',
            units: 'days'
          }
          this.dynamic_value_configuration = {}
          this.sendTime = {
            hours: '',
            minutes: ''
          }
          this.followupNudges = { context: null, delays: [] }
        }
        this.scheduledAppConversation = value.scheduledAppConversation || ''
        this.optionConfig = value.optionConfig
        this.msgTemplateName = value.msgTemplateName

        if (value.stageType === stageTypes.journeyReminder) {
          this.delay = {...value.joRDelayConfig.delay}
          this.sendTime = Object.keys({...value.joRDelayConfig.sendTime}).length > 0 ? {...value.joRDelayConfig.sendTime} : {
            hours: '',
            minutes: ''
          }
          this.msgTemplateName = value.jorTemplateName || ''
          this.dynamic_value_configuration = value.dynamic_value_configuration || {}
        }
        this.parseSemanticData()
      } else {
        this.stagename = ''
        this.options = ''
        this.nextStages = ''
        this.inputType = ''
        this.allMessages = []
        this.methods = {}
        this.nextApp = null
        this.subsequentApp = null
        this.recommendation = []
        this.tags = []
        this.optionScores = {}
        this.entries = []
        this.rankingScores = {}
        this.editedStage = ''
        this.notification = ''
        this.functionInput = ''
        this.functionName = ''
        this.functionDescription = ''
        this.failed = ''
        this.semantic = []
        this.delay = {
          quantity: '',
          units: 'days'
        }
        this.dynamic_value_configuration = {}
        this.sendTime = {
          hours: '',
          minutes: ''
        }
        this.scheduledAppKeyword = null
        this.scheduledKeywordlessConversation = null
        this.msgTemplateName = ''
        this.scheduledAppConversation = ''
        this.optionConfig = []
        this.isRedemptionStage = false
      }
    },
    validateScheduledAppKeywordNew (index, event) {
      this.entries[index].scheduledAppConversation = event ? `Conversation for ${event}` : null
      this.entries[index].isInvalidKeywordConversation = !event && !this.entries[index].scheduledKeywordlessConversation
    },
    validateScheduledKeywordlessConversationNew (index, event) {
      this.entries[index].isInvalidKeywordConversation = !event && !this.entries[index].scheduledAppKeyword
    }
  },
  data () {
    return {
      waitBetweenMessages: false,
      messageDelayMs: 2000,
      messageDelayLimits: { min: 100, max: 30000 },
      entries: [],
      uploadedMedia: null,
      mediaList: [],
      mediaByName: {},
      tags: [],
      tagTypes: tagTypes,
      selectedOfferings: [],
      allSelectedServices: false,
      allSelectedProducts: false,
      servicesList: [],
      productList: [],
      selectedKmDistance: null,
      selectedReferralType: null,
      selectedLocationType: null,
      specificReferralTypes,
      locationTypes,
      kmDistanceOptions,
      locationOptions: locationOptions,
      currentDynamicNudgeValue: null,
      dynamic_value_configuration: {},
      selectedDynamicNudgeData: null,
      isEditedNudgeDynamic: false,
      keywordlessConvoNew: [],
      scoredResponseConversation: [],
      scoredResponseConversationOptions: [],
      scoredResponseSelected: null,
      locationType: '',
      optionGenerateScoredResponse: [],
      newApps: [],
      newFunctionInput: [],
      convoCurrent: {},
      optionGenerate: [],
      selectedStages: [],
      selectedconversation: null,
      stageSelected: null,
      stageList: [],
      conversationList: [],
      conversationOptions: [],
      stageOptions: [],
      functionAlias: '',
      pfThatRequiresOptionsAutoMagically,
      ageList: [{
        ageLowerLimit: null,
        ageUpperLimit: null
      }],
      keywordMappingList: [{
        conversationId: null,
        keywordsList: [],
        mappingUniqueId: ''
      }],
      isValidKeywordMappingList: false,
      currentStoredValue: null,
      selectedCategory: [],
      loading: false,
      methodTypeModificationRequired: false,
      editedStage: '',
      stagename: '',
      stagetype: stageTypes.traditional,
      contextOptions: contextOptions,
      mediatype: 'text',
      options: '',
      conversation: '',
      nextStages: '',
      inputType: '',
      failed: '',
      nextApp: null,
      subsequentApp: null,
      referralType: null,
      additionalReferralConfig: {
        showPhysicalResouceAsPerPubliCPrivateSelection: false
      },
      referralAppOptions: referralAppOptions, // 0 - Expand All, 1 - Collapse All
      recommendation: [],
      notification: '',
      propertyKeys: {
        skip: [],
        text: []
      },
      allMessages: [],
      methods: {},
      methodOption: '',
      methodTypeModification: '',
      choosenMethods: [],
      submitted: false,
      frmAddRemoveMethodSubmitted: false,
      semantic: [],
      semanticData: [],
      showModalSemantic: false,
      showModalNullListInfo: false,
      showRedemptionStageInfo: false,
      showModalPf: false,
      semanticObj: {
        option: '',
        next: '',
        optionScore: '',
        tallyLowerLimit: null,
        tallyUpperLimit: null,
        semantic: {},
        isDynamicOptionsEnable: false,
        optionListSource: '',
        staticOptionTextConfig: {},
        dataDestination: ''
      },
      rankingScores: {},
      optionScores: {},
      submittedSemantic: false,
      showValidationError: false,
      showMessageSetValidationError: false,
      errorMessage: '',
      messageSetErrorMessage: '',
      draggable: true,
      languages: [],
      semanticMessage: '',
      isSemanticMessageEdit: false,
      selectedCountrySemantic: '',
      messageLanguageSemantic: '',
      subsequentAppEnabledFor: [
        'APP_LOCATION',
        'APP_UNIFIED_REFERRAL'
      ],
      copyOfFilteredApps: [],
      delay: {
        quantity: '',
        units: 'days'
      },
      sendTime: {
        hours: '',
        minutes: ''
      },
      stageTypes: stageTypes,
      scheduledAppKeyword: null,
      msgTemplateName: '',
      isInvalidDelay: false,
      isTotalDelay: false,
      isInvalidSendTime: false,
      isInvalidMessageTemplate: false,
      isDisabledSubsequentApp: true,
      allKeywords: [],
      nudgesList: [],
      isDisableKeyword: false,
      scheduledAppConversation: '',
      scheduledKeywordlessConversation: '',
      followupNudges: {
        context: null,
        delays: []
      },
      allRecommendationMethods: {},
      optionConfig: [],
      languagesForStaticOption: [],
      selectedCountryStaticOption: '',
      textLanguageStaticOption: '',
      staticOptionDisplayText: '',
      availableDataDestination: [],
      toggleSwitchRecommendation: false,
      showDelayTactics: false,
      showRecommendation: false,
      toggleSwitchDelay: false,
      toggleConditionalBranching: false,
      showConditionalBranching: false,
      functionName: '',
      functionInput: '',
      functionDescription: '',
      embeddedApp: null,
      topic: null,
      topicList: [],
      frequency: 'DAILY',
      isInvalidKeywordConversation: false,
      showNudgePreview: false,
      turnCountry: '',
      turnCountryList: [],
      showCountryPicker: false,
      lastNudgePreviewArgs: null,
      isInputRequired: true,
      isDefaultRequired: true,
      nudgePreviewData: [],
      categories: [],
      demographicOptions,
      demographicValue: null,
      optionDisplayArr: [],
      initialReferralsList: [],
      referralValues: [],
      pfStoredReferralsList: [],
      isRedemptionStage: false,
      whatsappFlowId: '',
      whatsappFlows: [
        { name: 'FP_SURVEY_INDIA_STAGING', id: '1666360934811162' },
        { name: 'FP_SURVEY_INDIA_ENGLISH', id: '3921396577991564' },
        { name: 'FP_SURVEY_INDIA_HINDI', id: '2115540582569417' },
        { name: 'FP_SURVEY_KENYA_STAGING', id: '1666360934811162' },
        { name: 'FP_SURVEY_KENYA_ENGLISH', id: '1865166474192175' },
        { name: 'FP_SURVEY_KENYA_SWAHILI', id: '1209678344440968' },
        { name: 'MH_JOURNEY_ONBOARDING_DEMO', id: '1598413114550118' }
      ]
    }
  },
  watch: {
    allApps: function (value) {
      this.newApps = value
      this.keywordlessConvoNew = value.filter(item => {
        return item.convoType === 'CONVERSATION'
      })
    },
    currentConvo: {
      immediate: true,
      handler: function (value) {
        console.log('convoCurrent: ', value)
        this.convoCurrent = value
        this.syncMessageDelayFromConvo(value)
      }
    },
    filteredApps: function (value) {
      if (value.length > 0) {
        let data = this.filteredApps.find(item => item.data && item.data.name === this.convoCurrent.name)
        if (!data) {
          value.push({
            'data': this.convoCurrent
          })
        }
      }
      this.getConversationsList(value)
    },
    functions: function (value) {
      let temp = []
      value.forEach((val, index) => {
        if (!temp.includes(val.category)) {
          this.categories.push({ id: index, label: val.category })
          temp.push(val.category)
        }
      })
    },
    conversationType: function (value) {
      if (value !== stageTypes.scoredResponse) {
        this.stagetype = stageTypes.traditional
      }
    },
    stagetype: function (value) {
      console.log('on stage type change', JSON.parse(JSON.stringify(this.delay)))
      this.scheduledAppConversation = ''
      this.scheduledAppKeyword = null
      this.scheduledKeywordlessConversation = null
      this.nextApp = null
      this.subsequentApp = null
      this.referralType = null
      this.additionalReferralConfig = {
        showPhysicalResouceAsPerPubliCPrivateSelection: false
      }
      this.recommendation = []
      this.tags = []
      this.msgTemplateName = ''
      this.delay.quantity = ''
      this.delay.units = 'days'
      this.sendTime.hours = ''
      this.sendTime.minutes = ''
      this.inputType = ''
      if (value !== stageTypes.embeddedConversation) {
        this.mediatype = 'text'
      }
      if (value === stageTypes.fbOptIn || value === stageTypes.journeyReminder) {
        this.mediatype = 'text'
        this.inputType = 'Text'
      }
    },
    allMethods: function (value) {
      const methodsScreening = this.screeningMethods
      for (var opt of methodsScreening) {
        if (value[opt]) {
          this.allRecommendationMethods[opt] = value[opt]
        }
      }
    },
    screeningMethods: function (value) {
      this.setRecommendations(value)
    },
    stageDetails: async function (value) {
      await this.parseStageDetails(value)
      // Lets the page hide its "Loading stage…" overlay once the form shows the new stage
      this.$nextTick(() => this.$emit('stageReady'))
    }
  },
  computed: {
    // The Media Management row for the picked "Uploaded Media", for its preview.
    selectedMedia () {
      return (this.mediatype === 'uploadedMedia' && this.uploadedMedia && this.mediaByName[this.uploadedMedia]) || null
    },
    isMessageDelayValid: function () {
      const { min, max } = this.messageDelayLimits
      return Number.isInteger(this.messageDelayMs) && this.messageDelayMs >= min && this.messageDelayMs <= max
    },
    allOptions: function () {
      return this.options.split(/,\s*/)
    },
    showMethodsTable: function () {
      return Object.keys(this.methods).length
    },
    caption: function () {
      return this.editedStage ? 'Update Stage' : 'Add Stage'
    },
    captionSemationPopup: function () {
      return this.isSemanticMessageEdit ? 'Update Option / Next Stage / Semantic' : 'Add Option / Next Stage / Semantic'
    },
    disableStageName: function () {
      return this.stagename === 'uninitialized'
    },
    externalConversationButton: function () {
      if (this.embeddedApp && this.embeddedApps.find(item => item.id === this.embeddedApp)) {
        return this.embeddedApps.find(item => item.id === this.embeddedApp).data
      }
      return false
    },
    conversationNotExistError: function () {
      return ((this.embeddedApp && !this.embeddedApps.find(item => item.id === this.embeddedApp)) || (this.selectedconversation && !this.conversationOptions.find(item => item.id === this.selectedconversation)) || (this.scoredResponseSelected && !this.scoredResponseConversationOptions.find(item => item.id === this.scoredResponseSelected)))
    }
  }
}
</script>

<style>
.stage-media-preview {
  max-width: 280px;
  margin-top: 10px;
}
.turn-country-hint {
  margin-left: 4px;
  color: #777;
  white-space: nowrap;
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  padding-right: 15px;
  padding-left: 15px;
}

.public-private-checkbox {
  font-weight: bold;
  margin-top:10px;
}

.btn-rounded {
  border-radius: 100%;
  font-weight: bold;
}

.flex-message-template {
  display: flex;
  flex-direction: row;
}

.flex-item {
  flex-grow: 1;
  flex-basis: 0;
  padding-right: 15px;
  padding-left: 15px;
  min-width: 300px;
}

.flex-small-item {
  flex-grow: 1;
  flex-basis: 0;
  padding-right: 15px;
  padding-left: 15px;
  min-width: 180px;
}

.btn-remove-nudge {
  margin-left: 10px;
  align-self: center;
}

.btn-nudge {
  height: 26px;
  min-width: 26px;
  width: 26px;
  font-size: 15px;
  padding: 0px;
}

.form-group--error {
  border: 1px solid red;
}

.disabledDiv {
    pointer-events: none;
    opacity: 0.4;
}

.message-timing {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}
.message-timing-title {
  font-weight: bold;
  margin-top: 0;
}
.message-timing-hint {
  color: #888;
}
.message-timing-toggle-label {
  margin-left: 10px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #0D9488;
}

input:focus + .slider {
  box-shadow: 0 0 1px #0D9488;
}

.option-border {
  border: 2px dashed grey;  /* Grey dotted border */
  padding: 10px;  /* Adds spacing inside the box */
  margin-top: 5px;
  margin-bottom: 15px; /* Adds spacing below */
  border-radius: 5px; /* Optional: Rounds the corners */
}

input:checked + .slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 25px;
}

.slider.round:before {
  border-radius: 50%;
}
.embedded_conversation_container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.conversation_dropdown_container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.wrap-text-list {
  width: 100%;
  word-break: break-all;
  text-align: center;
  white-space: normal;
}
.wrap-text-block {
  display: block;
  width: 100%;
  word-break: break-word;
}
.edit-delete-btn-container {
  width: 100px;
  display: flex;
  border-bottom: none;
  justify-content: space-between;
}
.auto-sync-container {
  display: flex;
  justify-content: center;
}
.auto-sync-sub-container {
  width: 200px;
  background: #0D9488;
  box-shadow: 0 2px 8px -2px rgba(13, 148, 136, 0.3);
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  border-radius: 20px;
  font-weight: bold;
}
.auto-sync-text {
  font-size: 16px;
  color: white;
}
.btn-configurepf {
  font-weight: bold;
  background-color: #0D9488;
  border-color: #0D9488;
  color: white !important;
  text-decoration: none;
}
.btn-resetvalues {
  background-color: #0D9488;
  border-color: #0D9488;
  font-weight: bold;
  color: white;
}
.applyStyleToRemove{
  margin-right: -550px;
  background-color: #0D9488;
  border-color: #0D9488;
  color: #fff;
  border-radius: 5px;
  margin-top: 20px;
}
.btn-generateoption{
  background-color: #0D9488;
  border-color: #0D9488;
  margin-top: 7px;
}
.btn-deletepf{
  background-color: #0D9488;
  border-color: #0D9488;
  color: #fff !important;
  text-decoration: none;
  font-weight: bold;
  margin-left: 13px;
}
.collapsable-link-panel-child-1{
  text-align: center;
  background: #0D9488 !important;
  border-radius: 1.2px;
}
.component-style{
  width: 630px;
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1px solid;
  border-color: #0D9488;
}
.age-container{
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-top: 8px;
}
.typepf_reset{
  display: flex;;
  align-items: center;
  justify-content: space-between;
  width: 85%;
}
.alignfd{
  display: flex;
  align-items: center;
}
.displaypf{
  margin-left: 13px;
}
select::option{
  color: gray;
}
.displayOptions{
  border-width:2px; 
  border-style:solid; 
  border-color:antiquewhite; 
  padding: 8px; 
  background-color: antiquewhite; 
  margin: 10px 5px 10px 5px;
  border-radius: 10px; 
  display: inline-block;
}
.displayOptionsLabel{
  margin: 10px 5px 5px 5px;
}
.input-stage{
  margin-top: 25px;
}
.footer-buttons {
  display: flex;
  justify-content: space-between;
}
.reload-conversation {
  display: flex;
}
</style>
<style scoped>
/* Stage Settings header: the whole bar toggles it, the chevron shows whether it's open. */
.panel-heading .collapsable-link-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 11px 16px;
  text-align: left;
  font-size: 15px;
}
.panel-heading .collapsable-link-panel::after {
  content: '\f078';
  font-family: FontAwesome;
  font-size: 12px;
  opacity: 0.8;
  transition: transform 0.15s ease;
}
.panel-heading .collapsable-link-panel.collapsed::after {
  transform: rotate(-90deg);
}
</style>



// WEBPACK FOOTER //
// stage.vue?38efbdf2